// Mock API for local development
// 介護スケジュール自動生成システム - モックAPI

import { User, MonthlySchedule, HistoricalSchedule, DayOfWeek, EventCategory, ScheduleTheme, DailyEvent } from '../types';
import { ApiResponse } from './api-client';

// Mock themes for different seasons
const mockThemes: ScheduleTheme[] = [
  {
    id: 'spring',
    name: '春のテーマ',
    primaryColor: '#ff69b4',
    secondaryColor: '#98fb98',
    season: 'spring',
    headerImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InNwcmluZyIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6I2ZmYjZjMTtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiM5OGZiOTg7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNzcHJpbmcpIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+🌸 春の季節 🌸PC90ZXh0Pjwvc3ZnPg==',
    backgroundImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0ic3ByaW5nUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48Y2lyY2xlIGN4PSIyNSIgY3k9IjI1IiByPSIzIiBmaWxsPSIjZmZiNmMxIiBvcGFjaXR5PSIwLjMiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNmOWY5ZjkiLz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3NwcmluZ1BhdHRlcm4pIi8+PC9zdmc+'
  },
  {
    id: 'summer',
    name: '夏のテーマ',
    primaryColor: '#00bfff',
    secondaryColor: '#ffff00',
    season: 'summer',
    headerImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9InN1bW1lciIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzAwYmZmZjtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiNmZmZmMDA7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNzdW1tZXIpIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+☀️ 夏の季節 ☀️PC90ZXh0Pjwvc3ZnPg==',
    backgroundImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0ic3VtbWVyUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjYwIiBoZWlnaHQ9IjYwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48Y2lyY2xlIGN4PSIzMCIgY3k9IjMwIiByPSI0IiBmaWxsPSIjMDBiZmZmIiBvcGFjaXR5PSIwLjIiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNmMGY4ZmYiLz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3N1bW1lclBhdHRlcm4pIi8+PC9zdmc+'
  },
  {
    id: 'autumn',
    name: '秋のテーマ',
    primaryColor: '#ff8c00',
    secondaryColor: '#dc143c',
    season: 'autumn',
    headerImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImF1dHVtbiIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6I2ZmOGMwMDtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiNkYzE0M2M7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNhdXR1bW4pIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+🍁 秋の季節 🍁PC90ZXh0Pjwvc3ZnPg==',
    backgroundImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iYXV0dW1uUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cG9seWdvbiBwb2ludHM9IjIwLDUgMjUsOCAxOCwxNSAyMiwxNSAxNSwyMiA4LDE1IDEyLDE1IDUsMTAgMTAsNyIgZmlsbD0iI2ZmOGMwMCIgb3BhY2l0eT0iMC4zIi8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZmZmOGYwIi8+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNhdXR1bW5QYXR0ZXJuKSIvPjwvc3ZnPg=='
  },
  {
    id: 'winter',
    name: '冬のテーマ',
    primaryColor: '#4169e1',
    secondaryColor: '#ffffff',
    season: 'winter',
    headerImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9IndpbnRlciIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzQxNjllMTtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiNmZmZmZmY7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCN3aW50ZXIpIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+❄️ 冬の季節 ❄️PC90ZXh0Pjwvc3ZnPg==',
    backgroundImage: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0id2ludGVyUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjMwIiBoZWlnaHQ9IjMwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48Y2lyY2xlIGN4PSIxNSIgY3k9IjE1IiByPSIyIiBmaWxsPSIjNDE2OWUxIiBvcGFjaXR5PSIwLjIiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNmNWY1ZjUiLz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI3dpbnRlclBhdHRlcm4pIi8+PC9zdmc+'
  }
];

// Mock data
const mockUsers: User[] = [
  {
    id: '1',
    name: '田中太郎',
    availableDays: [DayOfWeek.Monday, DayOfWeek.Wednesday, DayOfWeek.Friday],
    createdAt: new Date('2024-01-01'),
    updatedAt: new Date('2024-01-01')
  },
  {
    id: '2',
    name: '佐藤花子',
    availableDays: [DayOfWeek.Tuesday, DayOfWeek.Thursday],
    createdAt: new Date('2024-01-02'),
    updatedAt: new Date('2024-01-02')
  },
  {
    id: '3',
    name: '鈴木一郎',
    availableDays: [DayOfWeek.Monday, DayOfWeek.Tuesday, DayOfWeek.Wednesday, DayOfWeek.Thursday, DayOfWeek.Friday],
    createdAt: new Date('2024-01-03'),
    updatedAt: new Date('2024-01-03')
  }
];

const mockSchedule: MonthlySchedule = {
  id: 'schedule-2024-01',
  year: 2024,
  month: 1,
  events: [
    {
      id: 'event-1',
      date: new Date('2024-01-01'),
      eventName: 'お正月レクリエーション',
      eventType: 'レクリエーション',
      eventCategory: EventCategory.Hobby,
      assignedUserIds: ['1', '3']
    },
    {
      id: 'event-2',
      date: new Date('2024-01-02'),
      eventName: '健康体操',
      eventType: '体操',
      eventCategory: EventCategory.HealthBeauty,
      assignedUserIds: ['2']
    },
    {
      id: 'event-3',
      date: new Date('2024-01-03'),
      eventName: '手工芸作業',
      eventType: '作業',
      eventCategory: EventCategory.Work,
      assignedUserIds: ['1', '2']
    }
  ],
  generatedAt: new Date('2024-01-01')
};

// Simulate API delay
const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));

// やりたいこと（利用者リクエスト）の型
export interface UserWish {
  id: string;
  userName: string;
  wishText: string;
  createdAt: Date;
}

export class MockApiClient {
  private users: User[] = [...mockUsers];
  private schedules: MonthlySchedule[] = [mockSchedule];
  private themes: ScheduleTheme[] = [...mockThemes];
  private customImages: Map<string, string> = new Map(); // scheduleId -> base64 image data
  
  // Store uploaded images by month for automatic use
  private uploadedMonthlyImages: { [month: number]: { header?: string; background?: string } } = {};
  
  // Store uploaded historical schedules for reference during generation
  private uploadedHistoricalSchedules: HistoricalSchedule[] = [];
  
  // やりたいこと（利用者リクエスト）を保存
  private userWishes: UserWish[] = [];
  
  // Monthly default images library (fallback when no uploaded images)
  private monthlyImages = {
    1: { // January
      header: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImphbiIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6IzRkNzNkZjtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiNmZmZmZmY7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNqYW4pIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+🎍 1月 新年 🎍PC90ZXh0Pjwvc3ZnPg==',
      background: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iamFuUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48Y2lyY2xlIGN4PSIyMCIgY3k9IjIwIiByPSIzIiBmaWxsPSIjNGQ3M2RmIiBvcGFjaXR5PSIwLjE1Ii8+PC9wYXR0ZXJuPjwvZGVmcz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjhmOWZhIi8+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNqYW5QYXR0ZXJuKSIvPjwvc3ZnPg=='
    },
    2: { // February
      header: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48bGluZWFyR3JhZGllbnQgaWQ9ImZlYiIgeDE9IjAlIiB5MT0iMCUiIHgyPSIxMDAlIiB5Mj0iMTAwJSI+PHN0b3Agb2Zmc2V0PSIwJSIgc3R5bGU9InN0b3AtY29sb3I6I2ZmNjk5NDtzdG9wLW9wYWNpdHk6MSIgLz48c3RvcCBvZmZzZXQ9IjEwMCUiIHN0eWxlPSJzdG9wLWNvbG9yOiNmZmZmZmY7c3RvcC1vcGFjaXR5OjEiIC8+PC9saW5lYXJHcmFkaWVudD48L2RlZnM+PHJlY3Qgd2lkdGg9IjEwMCUiIGhlaWdodD0iMTAwJSIgZmlsbD0idXJsKCNmZWIpIiAvPjx0ZXh0IHg9IjUwJSIgeT0iNTAlIiBmb250LWZhbWlseT0iQXJpYWwsIHNhbnMtc2VyaWYiIGZvbnQtc2l6ZT0iMjQiIGZpbGw9IndoaXRlIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBkeT0iLjNlbSI+💖 2月 バレンタイン 💖PC90ZXh0Pjwvc3ZnPg==',
      background: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjMwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZGVmcz48cGF0dGVybiBpZD0iZmViUGF0dGVybiIgeD0iMCIgeT0iMCIgd2lkdGg9IjUwIiBoZWlnaHQ9IjUwIiBwYXR0ZXJuVW5pdHM9InVzZXJTcGFjZU9uVXNlIj48cGF0aCBkPSJNMjUsMzVjLTEwLTEwLTIwLTEwLTIwLTIwczEwLTEwLDIwLDBjMTAtMTAsMjAtMTAsMjAsMHMtMTAsMTAtMjAsMjB6IiBmaWxsPSIjZmY2OTk0IiBvcGFjaXR5PSIwLjIiLz48L3BhdHRlcm4+PC9kZWZzPjxyZWN0IHdpZHRoPSIxMDAlIiBoZWlnaHQ9IjEwMCUiIGZpbGw9IiNmZmY1ZjgiLz48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSJ1cmwoI2ZlYlBhdHRlcm4pIi8+PC9zdmc+'
    }
    // ... (continuing with other months)
  };
  // Authentication (Mock)
  async login(username: string, password: string): Promise<{ token: string; user: any }> {
    await delay(800);
    
    // Mock authentication - accept any non-empty credentials
    if (!username.trim() || !password) {
      throw new Error('ユーザー名またはパスワードが正しくありません');
    }

    // Mock user data
    const mockUser = {
      id: 'user-1',
      username: username.trim(),
      role: username.toLowerCase() === 'admin' ? 'admin' : 'staff'
    };

    return {
      token: `mock-token-${Date.now()}`,
      user: mockUser
    };
  }

  async logout(): Promise<void> {
    await delay(200);
    // Mock logout - always succeeds
  }

  async verifyToken(): Promise<{ user: any }> {
    await delay(300);
    
    // Mock token verification - always succeeds if token exists
    const token = localStorage.getItem('authToken');
    if (!token) {
      throw new Error('Invalid token');
    }

    return {
      user: {
        id: 'user-1',
        username: 'admin',
        role: 'admin'
      }
    };
  }

  // User Management
  async getAllUsers(): Promise<ApiResponse<User[]>> {
    await delay(500); // Simulate network delay
    return {
      success: true,
      data: this.users
    };
  }

  async getUser(id: string): Promise<ApiResponse<User>> {
    await delay(300);
    const user = this.users.find(u => u.id === id);
    if (!user) {
      return {
        success: false,
        error: {
          code: 'USER_NOT_FOUND',
          message: 'ユーザーが見つかりません',
          timestamp: new Date()
        }
      };
    }
    return {
      success: true,
      data: user
    };
  }

  async createUser(userData: Omit<User, 'id' | 'createdAt' | 'updatedAt'>): Promise<ApiResponse<User>> {
    await delay(800);
    
    // Validation
    if (!userData.name || userData.name.trim() === '') {
      return {
        success: false,
        error: {
          code: 'INVALID_NAME',
          message: '利用者名は必須です',
          timestamp: new Date()
        }
      };
    }

    if (!userData.availableDays || userData.availableDays.length === 0) {
      return {
        success: false,
        error: {
          code: 'INVALID_DAYS',
          message: '参加可能曜日を選択してください',
          timestamp: new Date()
        }
      };
    }

    const newUser: User = {
      id: `user-${Date.now()}`,
      name: userData.name.trim(),
      availableDays: userData.availableDays,
      createdAt: new Date(),
      updatedAt: new Date()
    };

    this.users.push(newUser);
    return {
      success: true,
      data: newUser
    };
  }

  async updateUser(id: string, userData: Partial<Omit<User, 'id' | 'createdAt'>>): Promise<ApiResponse<User>> {
    await delay(600);
    
    const userIndex = this.users.findIndex(u => u.id === id);
    if (userIndex === -1) {
      return {
        success: false,
        error: {
          code: 'USER_NOT_FOUND',
          message: 'ユーザーが見つかりません',
          timestamp: new Date()
        }
      };
    }

    const updatedUser = {
      ...this.users[userIndex],
      ...userData,
      updatedAt: new Date()
    };

    this.users[userIndex] = updatedUser;
    return {
      success: true,
      data: updatedUser
    };
  }

  async deleteUser(id: string): Promise<ApiResponse<void>> {
    await delay(400);
    
    const userIndex = this.users.findIndex(u => u.id === id);
    if (userIndex === -1) {
      return {
        success: false,
        error: {
          code: 'USER_NOT_FOUND',
          message: 'ユーザーが見つかりません',
          timestamp: new Date()
        }
      };
    }

    this.users.splice(userIndex, 1);
    return {
      success: true
    };
  }

  // Schedule Management
  async getSchedule(year: number, month: number): Promise<ApiResponse<MonthlySchedule>> {
    await delay(700);
    
    const schedule = this.schedules.find(s => s.year === year && s.month === month);
    if (!schedule) {
      return {
        success: false,
        error: {
          code: 'SCHEDULE_NOT_FOUND',
          message: '指定された年月のスケジュールが見つかりません',
          timestamp: new Date()
        }
      };
    }

    return {
      success: true,
      data: schedule
    };
  }

  async generateSchedule(year: number, month: number): Promise<ApiResponse<MonthlySchedule>> {
    await delay(2000); // Simulate longer processing time
    
    console.log('=== SCHEDULE GENERATION START ===');
    console.log(`Generating schedule for ${year}年${month}月`);
    console.log(`Available historical schedules: ${this.uploadedHistoricalSchedules.length}`);
    
    // 🔍 デバッグ: アップロードされた履歴データの詳細を表示
    if (this.uploadedHistoricalSchedules.length > 0) {
      console.log('📁 Historical data will be used for event names:');
      this.uploadedHistoricalSchedules.forEach((schedule, index) => {
        console.log(`  Schedule ${index + 1}: ${schedule.year}年${schedule.month}月 (${schedule.events.length} events)`);
        
        // 1月のイベントのみを表示
        const januaryEvents = schedule.events.filter(e => new Date(e.date).getMonth() + 1 === 1);
        console.log(`  🎍 1月のイベント数: ${januaryEvents.length}`);
        if (januaryEvents.length > 0) {
          console.log('  1月のイベント例:');
          januaryEvents.slice(0, 10).forEach(event => {
            console.log(`    - ${event.eventName} (${event.eventCategory})`);
          });
        }
      });
    } else {
      console.log('📅 No historical data available, using seasonal event names');
      console.log('⚠️ ファイルをアップロードしていない、またはページをリフレッシュした可能性があります');
    }
    
    // Generate mock schedule
    const events = [];
    const daysInMonth = new Date(year, month, 0).getDate();
    
    // Track used event names to avoid duplicates
    const usedEventNames = new Set<string>();
    
    // 曜日ごとに使用したイベントを追跡（月全体で同じ曜日に同じイベントが出現しないようにする）
    const usedEventsByDayOfWeek: { [dayOfWeek: number]: Set<string> } = {};
    for (let dow = 1; dow <= 7; dow++) {
      usedEventsByDayOfWeek[dow] = new Set<string>();
    }
    
    // Category distribution tracking for balance
    const categoryUsageTracker = {
      [EventCategory.Work]: 0,
      [EventCategory.HealthBeauty]: 0,
      [EventCategory.Hobby]: 0,
      [EventCategory.Life]: 0
    };

    // Weekly category distribution to ensure variety within each week
    const weeklyTracker: { [week: number]: { [category: string]: number } } = {};
    
    // Daily category distribution to ensure variety on same day of week
    const dailyTracker: { [dayOfWeek: number]: { [category: string]: number } } = {};
    
    // Initialize daily tracker for all days of week
    for (let dow = 0; dow <= 7; dow++) {
      dailyTracker[dow] = {
        [EventCategory.Work]: 0,
        [EventCategory.HealthBeauty]: 0,
        [EventCategory.Hobby]: 0,
        [EventCategory.Life]: 0
      };
    }
    
    // === カテゴリ均等配置方式 ===
    // その月のアップロードデータからカテゴリ別にイベントを取得し、
    // ラウンドロビンで均等に配置する
    
    const allCategories = [EventCategory.Work, EventCategory.HealthBeauty, EventCategory.Hobby, EventCategory.Life];
    
    // カテゴリ別にイベントプールを構築
    const eventsByCategory: { [cat: string]: string[] } = {
      [EventCategory.Work]: [],
      [EventCategory.HealthBeauty]: [],
      [EventCategory.Hobby]: [],
      [EventCategory.Life]: []
    };
    
    if (this.uploadedHistoricalSchedules.length > 0) {
      const allEvents = this.uploadedHistoricalSchedules.flatMap(schedule => schedule.events);
      console.log(`📊 Total uploaded events across all months: ${allEvents.length}`);
      
      // 月ごとのイベント数を確認
      const monthCounts: { [m: number]: number } = {};
      for (const event of allEvents) {
        const em = new Date(event.date).getMonth() + 1;
        monthCounts[em] = (monthCounts[em] || 0) + 1;
      }
      console.log(`📊 Events by month:`, monthCounts);
      
      // 対象月のイベントをカテゴリ別に収集
      const seenNames = new Set<string>();
      const monthEvents = allEvents.filter(event => {
        const eventMonth = new Date(event.date).getMonth() + 1;
        return eventMonth === month;
      });
      
      console.log(`📊 Events for month ${month}: ${monthEvents.length}`);
      
      // 月限定イベントのフィルタ（その月以外では使わない）
      const monthSpecificKeywords: { [m: number]: string[] } = {
        1: ['初詣', 'お正月', '新年', '門松', '書初め', 'おせち', 'お年玉', '年賀状'],
        2: ['節分', 'バレンタイン'],
        3: ['ひな祭り', '雛祭り', 'ひなまつり'],
        4: ['お花見', '花見'],
        5: ['こどもの日', '子供の日', 'こいのぼり', '母の日'],
        6: ['父の日'],
        7: ['七夕', 'たなばた'],
        8: ['お盆', '盆踊り'],
        9: ['お月見', '月見', '敬老の日'],
        10: ['ハロウィン', 'Halloween'],
        11: ['文化の日', '文化祭'],
        12: ['クリスマス', 'Xmas', '忘年会', '年末', '冬至', '大晦日']
      };
      
      const isWrongMonthEvent = (eventName: string, targetMonth: number): boolean => {
        for (const [m, keywords] of Object.entries(monthSpecificKeywords)) {
          const eventMonth = parseInt(m);
          if (eventMonth === targetMonth) continue;  // 対象月のキーワードはOK
          for (const kw of keywords) {
            if (eventName.includes(kw)) {
              console.log(`  🚫 Filtering "${eventName}" - ${kw} is for month ${eventMonth}, not ${targetMonth}`);
              return true;
            }
          }
        }
        return false;
      };
      
      for (const event of monthEvents) {
        if (!seenNames.has(event.eventName) && !isWrongMonthEvent(event.eventName, month)) {
          seenNames.add(event.eventName);
          const cat = this.determineCategoryFromName(event.eventName);
          eventsByCategory[cat].push(event.eventName);
        }
      }
      
      // もし対象月のイベントが0件なら、全月から取得（フォールバック）
      if (seenNames.size === 0) {
        console.log(`⚠️ No events found for month ${month}, using all uploaded events as fallback`);
        for (const event of allEvents) {
          if (!seenNames.has(event.eventName)) {
            seenNames.add(event.eventName);
            const cat = this.determineCategoryFromName(event.eventName);
            eventsByCategory[cat].push(event.eventName);
          }
        }
      }
      
      // 各カテゴリをシャッフル
      for (const cat of allCategories) {
        eventsByCategory[cat] = eventsByCategory[cat].sort(() => Math.random() - 0.5);
      }
      
      // デバッグ出力
      for (const cat of allCategories) {
        console.log(`📊 ${cat}: ${eventsByCategory[cat].length} events - ${eventsByCategory[cat].join(', ')}`);
      }
    }
    
    // 存在するカテゴリのみ使用
    const availableCategories = allCategories.filter(cat => eventsByCategory[cat].length > 0);
    console.log(`📊 Available categories: ${availableCategories.join(', ')}`);
    
    // === やりたいこと優先マップを構築 ===
    // 利用者名からその利用者の来る曜日を特定し、その曜日に優先イベントを設定
    const wishPriorityByDow: { [dayOfWeek: number]: string[] } = {};
    for (let dow = 1; dow <= 7; dow++) {
      wishPriorityByDow[dow] = [];
    }
    
    if (this.userWishes.length > 0) {
      console.log(`🌟 やりたいこと: ${this.userWishes.length}件`);
      for (const wish of this.userWishes) {
        // 利用者名で検索（部分一致）
        const matchedUser = this.users.find(u => 
          u.name.includes(wish.userName) || wish.userName.includes(u.name)
        );
        
        if (matchedUser) {
          for (const dow of matchedUser.availableDays) {
            wishPriorityByDow[dow].push(wish.wishText);
            console.log(`  🌟 ${wish.userName}(${matchedUser.name}) の曜日${dow}に「${wish.wishText}」を優先設定`);
          }
        } else {
          console.log(`  ⚠️ 利用者「${wish.userName}」が見つかりません`);
        }
      }
    }
    
    // カテゴリ別のインデックス（ラウンドロビン用）
    const categoryIndex: { [cat: string]: number } = {};
    for (const cat of allCategories) {
      categoryIndex[cat] = 0;
    }
    
    // カテゴリのラウンドロビン順序を作成
    let categoryRotation = [...availableCategories].sort(() => Math.random() - 0.5);
    let rotationIndex = 0;
    
    // Generate events for all days in the month
    for (let day = 1; day <= daysInMonth; day++) {
      const date = new Date(year, month - 1, day);
      const dayOfWeek = date.getDay() === 0 ? 7 : date.getDay();
      const isWeekend = dayOfWeek === 6 || dayOfWeek === 7;
      const weekNumber = Math.ceil(day / 7);
      
      // Initialize weekly tracker for new week
      if (!weeklyTracker[weekNumber]) {
        weeklyTracker[weekNumber] = {
          [EventCategory.Work]: 0,
          [EventCategory.HealthBeauty]: 0,
          [EventCategory.Hobby]: 0,
          [EventCategory.Life]: 0
        };
      }
      
      // Find users available on this day
      let availableUsers = this.users.filter(user => 
        user.availableDays.indexOf(dayOfWeek as DayOfWeek) !== -1
      );
      if (availableUsers.length === 0) {
        availableUsers = [...this.users];
      }

      // ラウンドロビンでカテゴリを選択
      let eventName: string | null = null;
      let selectedCategory: EventCategory | null = null;
      
      // イベント名の類似判定（先頭キーワードが同じなら類似とみなす）
      const isSimilarToUsed = (candidate: string, usedSet: Set<string>): boolean => {
        // 完全一致チェック
        if (usedSet.has(candidate)) return true;
        
        // キーワード抽出: 最初の2-5文字のひらがな/カタカナ/漢字部分
        const extractKeyword = (name: string): string => {
          const match = name.match(/^[ぁ-んァ-ヶー一-龠a-zA-Z]{2,5}/);
          return match ? match[0] : name.substring(0, 3);
        };
        
        const candidateKey = extractKeyword(candidate);
        
        for (const used of usedSet) {
          const usedKey = extractKeyword(used);
          // 先頭キーワードが一致したら類似
          if (candidateKey === usedKey && candidateKey.length >= 2) return true;
        }
        return false;
      };
      
      // === やりたいこと優先チェック ===
      const priorityWishes = wishPriorityByDow[dayOfWeek];
      if (priorityWishes && priorityWishes.length > 0) {
        const usedOnThisDow = usedEventsByDayOfWeek[dayOfWeek];
        // まだ使われていない「やりたいこと」を探す
        for (const wishEvent of priorityWishes) {
          if (!isSimilarToUsed(wishEvent, usedOnThisDow)) {
            eventName = wishEvent;
            // カテゴリを推定
            selectedCategory = this.determineCategoryFromName(wishEvent);
            console.log(`  🌟 Day ${day}: やりたいこと優先「${eventName}」[${selectedCategory}]`);
            break;
          }
        }
      }
      
      if (availableCategories.length > 0) {
        // ローテーションを使い切ったらリシャッフル
        if (rotationIndex >= categoryRotation.length) {
          categoryRotation = [...availableCategories].sort(() => Math.random() - 0.5);
          rotationIndex = 0;
        }
        
        // やりたいことで既にイベントが決まっている場合はカテゴリ選択のみ更新
        if (!eventName) {
          selectedCategory = categoryRotation[rotationIndex];
        }
        rotationIndex++;
        
        // そのカテゴリからイベントを取得（やりたいことで未設定の場合のみ）
        if (!eventName && selectedCategory) {
          const pool = eventsByCategory[selectedCategory];
          if (pool.length > 0) {
            const usedOnThisDow = usedEventsByDayOfWeek[dayOfWeek];
            let attempts = 0;
            const maxAttempts = pool.length;
            
            while (attempts < maxAttempts) {
              if (categoryIndex[selectedCategory] >= pool.length) {
                eventsByCategory[selectedCategory] = pool.sort(() => Math.random() - 0.5);
                categoryIndex[selectedCategory] = 0;
              }
              const candidate = pool[categoryIndex[selectedCategory]];
              categoryIndex[selectedCategory]++;
              attempts++;
              
              if (!isSimilarToUsed(candidate, usedOnThisDow)) {
                eventName = candidate;
                break;
              }
            }
            
            // 全て使用済みの場合、他のカテゴリから未使用イベントを探す
            if (!eventName) {
              for (const altCat of availableCategories) {
                if (altCat === selectedCategory) continue;
                const altPool = eventsByCategory[altCat];
                for (const candidate of altPool) {
                  if (!isSimilarToUsed(candidate, usedOnThisDow)) {
                    eventName = candidate;
                    selectedCategory = altCat;
                    break;
                  }
                }
                if (eventName) break;
              }
            }
            
            // それでも見つからない場合は重複を許容
            if (!eventName) {
              eventName = pool[Math.floor(Math.random() * pool.length)];
            }
          }
        }
      }
      
      if (eventName && selectedCategory) {
        const assignedUsers = this.getRandomUsers(availableUsers, Math.min(3, availableUsers.length));
        
        events.push({
          id: `event-${year}-${month}-${day}-1`,
          date,
          eventName: eventName,
          eventType: this.getEventTypeByCategory(selectedCategory),
          eventCategory: selectedCategory,
          assignedUserIds: assignedUsers.map((u: User) => u.id)
        });
        
        // Update trackers
        categoryUsageTracker[selectedCategory]++;
        weeklyTracker[weekNumber][selectedCategory]++;
        dailyTracker[dayOfWeek][selectedCategory]++;
        usedEventsByDayOfWeek[dayOfWeek].add(eventName);
        
        console.log(`  Day ${day}: ${eventName} [${selectedCategory}]`);
      } else {
        console.log(`  Day ${day}: ⚠️ No events available`);
      }
    }

    // Determine season based on month
    const season = this.getSeasonByMonth(month);
    const seasonalTheme = this.themes.find(t => t.season === season) || this.themes[0];
    
    // Get month-specific images (prioritize uploaded images, fallback to default)
    const uploadedImages = this.uploadedMonthlyImages[month];
    const defaultImages = this.monthlyImages[month as keyof typeof this.monthlyImages];
    
    console.log('=== SCHEDULE GENERATION IMAGE SELECTION ===');
    console.log('Month:', month);
    console.log('All uploaded monthly images:', this.uploadedMonthlyImages);
    console.log('Uploaded images for this month:', uploadedImages);
    console.log('Default images for this month:', defaultImages ? 'Available' : 'Not available');
    console.log('Seasonal theme:', seasonalTheme.name);
    
    // Select images with priority: uploaded > default > seasonal theme
    const selectedHeaderImage = uploadedImages?.header || defaultImages?.header || seasonalTheme.headerImage;
    const selectedBackgroundImage = uploadedImages?.background || defaultImages?.background || seasonalTheme.backgroundImage;
    
    console.log('Selected header image source:', 
      uploadedImages?.header ? 'Uploaded (User Image)' : 
      defaultImages?.header ? 'Default (Built-in)' : 'Seasonal theme');
    console.log('Selected background image source:', 
      uploadedImages?.background ? 'Uploaded (User Image)' : 
      defaultImages?.background ? 'Default (Built-in)' : 'Seasonal theme');
    
    console.log('Selected header image URL (first 100 chars):', 
      selectedHeaderImage ? selectedHeaderImage.substring(0, 100) + '...' : 'None');
    console.log('Selected background image URL (first 100 chars):', 
      selectedBackgroundImage ? selectedBackgroundImage.substring(0, 100) + '...' : 'None');
    
    // Create detailed image usage report
    const imageUsageReport = {
      headerImage: {
        source: uploadedImages?.header ? 'uploaded' : (defaultImages?.header ? 'default' : 'theme'),
        isUserUploaded: !!uploadedImages?.header,
        dataSize: selectedHeaderImage ? Math.round(selectedHeaderImage.length / 1024) : 0
      },
      backgroundImage: {
        source: uploadedImages?.background ? 'uploaded' : (defaultImages?.background ? 'default' : 'theme'),
        isUserUploaded: !!uploadedImages?.background,
        dataSize: selectedBackgroundImage ? Math.round(selectedBackgroundImage.length / 1024) : 0
      }
    };
    
    console.log('Image usage report:', imageUsageReport);
    console.log('=== SCHEDULE GENERATION IMAGE SELECTION END ===');

    const newSchedule: MonthlySchedule = {
      id: `schedule-${year}-${month}`,
      year,
      month,
      events,
      generatedAt: new Date(),
      theme: seasonalTheme,
      customImages: {
        headerImage: selectedHeaderImage,
        backgroundImage: selectedBackgroundImage
      }
    };

    // Add image usage metadata for debugging (as any to avoid type issues)
    (newSchedule as any).imageUsageReport = imageUsageReport;

    // Replace existing schedule for this month
    const existingIndex = this.schedules.findIndex(s => s.year === year && s.month === month);
    if (existingIndex >= 0) {
      this.schedules[existingIndex] = newSchedule;
    } else {
      this.schedules.push(newSchedule);
    }

    console.log('=== FINAL SCHEDULE CREATED ===');
    console.log('Schedule ID:', newSchedule.id);
    console.log(`📊 Generated ${events.length} events total`);
    
    // 履歴データの使用状況を確認
    if (this.uploadedHistoricalSchedules.length > 0) {
      const historicalEventNames = this.uploadedHistoricalSchedules
        .flatMap(schedule => schedule.events)
        .map(event => event.eventName);
      const usedHistoricalEvents = events.filter(event => 
        historicalEventNames.includes(event.eventName)
      );
      console.log(`📁 Historical events used: ${usedHistoricalEvents.length}/${events.length}`);
      console.log('Used historical event names:', usedHistoricalEvents.map(e => e.eventName));
    }
    
    console.log('Custom images in schedule:', {
      headerImage: newSchedule.customImages?.headerImage ? 'Present (length: ' + newSchedule.customImages.headerImage.length + ')' : 'Not present',
      backgroundImage: newSchedule.customImages?.backgroundImage ? 'Present (length: ' + newSchedule.customImages.backgroundImage.length + ')' : 'Not present'
    });
    
    // 各曜日のカテゴリ分布を確認
    console.log('=== CATEGORY DISTRIBUTION BY DAY OF WEEK ===');
    for (let dow = 1; dow <= 7; dow++) {
      const dayName = ['', '月', '火', '水', '木', '金', '土', '日'][dow];
      const categories = Object.keys(dailyTracker[dow]).filter(cat => dailyTracker[dow][cat] > 0);
      const missing = Object.keys(dailyTracker[dow]).filter(cat => dailyTracker[dow][cat] === 0);
      console.log(`${dayName}曜日: 含まれるカテゴリ [${categories.join(', ')}] | 不足カテゴリ [${missing.join(', ')}]`);
      console.log(`  詳細: ${JSON.stringify(dailyTracker[dow])}`);
    }
    console.log('=== FINAL SCHEDULE CREATED END ===');

    return {
      success: true,
      data: newSchedule
    };
  }

  async saveSchedule(schedule: MonthlySchedule): Promise<ApiResponse<MonthlySchedule>> {
    await delay(500);
    
    const existingIndex = this.schedules.findIndex(s => s.id === schedule.id);
    if (existingIndex >= 0) {
      this.schedules[existingIndex] = schedule;
    } else {
      this.schedules.push(schedule);
    }

    return {
      success: true,
      data: schedule
    };
  }

  // やりたいこと（利用者リクエスト）管理
  async addUserWish(userName: string, wishText: string): Promise<ApiResponse<UserWish>> {
    await delay(300);
    
    if (!userName.trim() || !wishText.trim()) {
      return {
        success: false,
        error: {
          code: 'INVALID_INPUT',
          message: '利用者名とやりたいことを入力してください',
          timestamp: new Date()
        }
      };
    }

    const newWish: UserWish = {
      id: `wish-${Date.now()}`,
      userName: userName.trim(),
      wishText: wishText.trim(),
      createdAt: new Date()
    };

    this.userWishes.push(newWish);
    console.log('✅ やりたいこと追加:', newWish);

    return {
      success: true,
      data: newWish
    };
  }

  async getUserWishes(): Promise<ApiResponse<UserWish[]>> {
    await delay(200);
    return {
      success: true,
      data: this.userWishes
    };
  }

  async deleteUserWish(wishId: string): Promise<ApiResponse<void>> {
    await delay(200);
    
    const index = this.userWishes.findIndex(w => w.id === wishId);
    if (index === -1) {
      return {
        success: false,
        error: {
          code: 'WISH_NOT_FOUND',
          message: 'やりたいことが見つかりません',
          timestamp: new Date()
        }
      };
    }

    this.userWishes.splice(index, 1);
    return {
      success: true
    };
  }

  // File Upload (Mock) - Enhanced to handle images and REAL Excel parsing
  async uploadExcelFile(file: File): Promise<ApiResponse<HistoricalSchedule>> {
    await delay(1500);
    
    console.log('=== EXCEL FILE UPLOAD WITH REAL PARSING ===');
    console.log('File type:', file.type);
    console.log('File name:', file.name);
    
    // Check if this is an image file instead of Excel
    if (file.type.startsWith('image/')) {
      console.log('Image file detected, processing as monthly image');
      
      // Extract month from current date or filename
      const currentMonth = new Date().getMonth() + 1;
      
      // Determine image type based on filename or default to header
      const isBackground = file.name.toLowerCase().includes('background') || 
                          file.name.toLowerCase().includes('背景') ||
                          file.name.toLowerCase().includes('bg');
      const imageType = isBackground ? 'background' : 'header';
      
      console.log(`Determined image type: ${imageType} for file: ${file.name}`);
      
      // Store as monthly image
      const base64 = await this.fileToBase64(file);
      
      if (!this.uploadedMonthlyImages[currentMonth]) {
        this.uploadedMonthlyImages[currentMonth] = {};
      }
      
      if (imageType === 'header') {
        this.uploadedMonthlyImages[currentMonth].header = base64;
        console.log(`✅ Header image stored for month ${currentMonth}, data length: ${base64.length}`);
      } else {
        this.uploadedMonthlyImages[currentMonth].background = base64;
        console.log(`✅ Background image stored for month ${currentMonth}, data length: ${base64.length}`);
      }
      
      console.log(`Image successfully stored as ${currentMonth}月の${imageType}画像`);
      console.log('Current uploaded monthly images after storage:', this.uploadedMonthlyImages);
      
      // Return a special response indicating image upload
      return {
        success: true,
        data: {
          id: `image-upload-${Date.now()}`,
          year: new Date().getFullYear(),
          month: currentMonth,
          events: [],
          uploadedAt: new Date(),
          imageInfo: {
            type: imageType,
            month: currentMonth,
            fileName: file.name,
            dataLength: base64.length,
            storedSuccessfully: true
          }
        } as any
      };
    }
    
    // REAL Excel file parsing using xlsx library
    console.log('📊 Reading actual Excel file:', file.name);
    
    try {
      // Import xlsx dynamically
      const XLSX = await import('xlsx');
      
      // Read the file as ArrayBuffer
      const arrayBuffer = await file.arrayBuffer();
      
      // Parse the Excel file with options to preserve full cell content
      const workbook = XLSX.read(arrayBuffer, { 
        type: 'array',
        cellText: false,  // Get raw cell values
        cellDates: true,  // Parse dates properly
        cellNF: false,    // Don't include number format
        cellStyles: false // Don't include styles
      });
      
      console.log('✅ Excel file parsed successfully');
      console.log('Sheet names:', workbook.SheetNames);
      
      const events: DailyEvent[] = [];
      let eventId = 1;
      
      // Helper function to determine event category from event name
      const determineCategory = (eventName: string): EventCategory => {
        const nameLower = eventName.toLowerCase();
        
        // 生活・Life keywords (優先度最高)
        if (nameLower.includes('お買い物') || nameLower.includes('買い物') || 
            nameLower.includes('ランチ') || nameLower.includes('お出かけ') || nameLower.includes('外出') ||
            nameLower.includes('ドライブ')) {
          return EventCategory.Life;
        }
        
        // 健康・美容・HealthBeauty keywords (優先度高)
        if (nameLower.includes('体操') || nameLower.includes('ヨガ') || nameLower.includes('ストレッチ') ||
            nameLower.includes('健康') || nameLower.includes('美容') || nameLower.includes('マッサージ') ||
            nameLower.includes('リラク') || nameLower.includes('アロマ') ||
            nameLower.includes('ウォーキング') || nameLower.includes('散歩') || nameLower.includes('ダンス') ||
            nameLower.includes('エクササイズ') || nameLower.includes('運動') || nameLower.includes('チェア') ||
            nameLower.includes('笑い')) {
          return EventCategory.HealthBeauty;
        }
        
        // 作業・Work keywords (農業系、販売系、おやつ作りのみ)
        if (nameLower.includes('園芸') || nameLower.includes('農') || nameLower.includes('畑') ||
            nameLower.includes('販売') ||
            nameLower.includes('おやつ作り') || nameLower.includes('お菓子作り')) {
          return EventCategory.Work;
        }
        
        // 趣味・レク・Hobby keywords
        if (nameLower.includes('レク') || nameLower.includes('カラオケ') || nameLower.includes('音楽') ||
            nameLower.includes('映画') || nameLower.includes('読書') || nameLower.includes('ゲーム') ||
            nameLower.includes('工作') || nameLower.includes('絵画') || nameLower.includes('書道') ||
            nameLower.includes('俳句') || nameLower.includes('将棋') || nameLower.includes('囲碁') ||
            nameLower.includes('パズル') || nameLower.includes('鑑賞')) {
          return EventCategory.Hobby;
        }
        
        // Default to Life
        return EventCategory.Life;
      };
      
      // Helper function to extract month and year from sheet name or title
      const extractMonthYear = (sheetName: string, jsonData: any[]): { year: number; month: number } | null => {
        // Try to find month/year in sheet name (e.g., "2月", "R7.2月")
        const sheetMatch = sheetName.match(/(\d+)年.*?(\d+)月|R(\d+)\.(\d+)|(\d+)月/);
        if (sheetMatch) {
          if (sheetMatch[1] && sheetMatch[2]) {
            return { year: parseInt(sheetMatch[1]), month: parseInt(sheetMatch[2]) };
          } else if (sheetMatch[3] && sheetMatch[4]) {
            // Reiwa year (R7 = 2025)
            const reiwaYear = parseInt(sheetMatch[3]);
            const year = 2018 + reiwaYear; // Reiwa 1 = 2019
            return { year, month: parseInt(sheetMatch[4]) };
          } else if (sheetMatch[5]) {
            return { year: new Date().getFullYear(), month: parseInt(sheetMatch[5]) };
          }
        }
        
        // Try to find in first few rows (title area)
        for (let i = 0; i < Math.min(5, jsonData.length); i++) {
          const row = jsonData[i] as any[];
          if (!row) continue;
          
          for (const cell of row) {
            if (!cell) continue;
            const cellStr = String(cell);
            const cellMatch = cellStr.match(/(\d+)年.*?(\d+)月|R(\d+)\.(\d+)|(\d+)月/);
            if (cellMatch) {
              if (cellMatch[1] && cellMatch[2]) {
                return { year: parseInt(cellMatch[1]), month: parseInt(cellMatch[2]) };
              } else if (cellMatch[3] && cellMatch[4]) {
                const reiwaYear = parseInt(cellMatch[3]);
                const year = 2018 + reiwaYear;
                return { year, month: parseInt(cellMatch[4]) };
              } else if (cellMatch[5]) {
                return { year: new Date().getFullYear(), month: parseInt(cellMatch[5]) };
              }
            }
          }
        }
        
        return null;
      };
      
      // Process each sheet (assuming each sheet is a month calendar)
      for (const sheetName of workbook.SheetNames) {
        console.log(`\n📄 Processing sheet: ${sheetName}`);
        
        const worksheet = workbook.Sheets[sheetName];
        
        // Convert sheet to JSON with options to preserve full cell content
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
          header: 1, 
          defval: null,
          raw: false,        // Convert to formatted strings
          blankrows: true    // Include blank rows
        });
        
        console.log(`Found ${jsonData.length} rows in sheet ${sheetName}`);
        
        // 🔍 デバッグ: 最初の30行をダンプしてExcelの構造を確認
        console.log(`\n🔍🔍🔍 SHEET DUMP: ${sheetName} (first 30 rows) 🔍🔍🔍`);
        for (let i = 0; i < Math.min(30, jsonData.length); i++) {
          const row = jsonData[i] as any[];
          if (row) {
            const cells = row.map((cell, idx) => `[${idx}]=${cell}`).filter(c => !c.endsWith('=null'));
            console.log(`  Row ${i}: ${cells.join(' | ')}`);
          } else {
            console.log(`  Row ${i}: (empty)`);
          }
        }
        console.log(`🔍🔍🔍 END SHEET DUMP 🔍🔍🔍\n`);
        
        // Extract month and year
        const monthYear = extractMonthYear(sheetName, jsonData);
        if (!monthYear) {
          console.warn(`⚠️ Could not determine month/year for sheet ${sheetName}, using current date`);
        }
        const year = monthYear?.year || new Date().getFullYear();
        const month = monthYear?.month || new Date().getMonth() + 1;
        
        console.log(`📅 Detected: ${year}年${month}月`);
        
        // === 全セルスキャン方式 ===
        // カレンダーグリッドの構造に依存せず、全セルをスキャンして
        // 日本語テキストを含むイベント名を抽出する
        
        // ヘルパー: セルの値を文字列に変換
        const cellToString = (cell: any): string => {
          if (!cell) return '';
          if (typeof cell === 'string') return cell;
          if (typeof cell === 'number') return String(cell);
          if (typeof cell === 'object') {
            if (cell.v !== undefined) return String(cell.v);
            if (cell.w !== undefined) return String(cell.w);
          }
          return String(cell);
        };
        
        // ヘルパー: テキストからイベント名を抽出（改行区切りで複数取得）
        const extractEventNames = (text: string): string[] => {
          const names: string[] = [];
          // 改行で分割
          const lines = text.split(/[\r\n]+/).map((l: string) => l.trim()).filter((l: string) => l.length > 0);
          
          for (const line of lines) {
            let cleaned = line
              .replace(/[♡★☆♪♥🎵🎶🌸🎍☀️🍁❄️💖]+/gu, '')
              .replace(/^(AM|PM|am|pm)\s*/i, '')
              .replace(/^\d{1,2}:\d{2}\s*/, '')  // 時刻を除去
              .replace(/^[\s　]+|[\s　]+$/g, '')  // 全角スペースも除去
              .trim();
            
            if (!cleaned) continue;
            
            // 「行事予定」「デイサービス」「プログラム」等を含むテキストはタイトル/ヘッダー
            if (/行事予定|デイサービス|プログラム|スケジュール表|活動表|月間予定/.test(cleaned)) continue;
            
            // スペース区切りで複数イベントが結合されている場合を分割
            // 各パーツが4文字以上かつ日本語漢字/ひらがな3文字以上を含む場合のみ分割
            const spaceParts = cleaned.split(/\s+/);
            const splitCandidates: string[] = [];
            
            if (spaceParts.length >= 2) {
              const validParts: string[] = [];
              for (const part of spaceParts) {
                if (part.length >= 4 && /[ぁ-んァ-ヶー一-龠]{3,}/.test(part)) {
                  validParts.push(part);
                }
              }
              
              if (validParts.length >= 2) {
                for (const part of validParts) {
                  splitCandidates.push(part);
                }
              } else {
                splitCandidates.push(cleaned.replace(/\s+/g, ''));
              }
            } else {
              splitCandidates.push(cleaned);
            }
            
            for (const candidate of splitCandidates) {
              const c = candidate.trim();
              if (!isValidEventName(c)) continue;
              names.push(c);
            }
          }
          return names;
        };
        
        // イベント名として有効かチェックする関数
        const isValidEventName = (c: string): boolean => {
          if (c.length < 3) return false;  // 3文字未満は無効
          if (c.length > 30) return false;
          if (/^\d+$/.test(c)) return false;
          if (/^(AM|PM|am|pm|\d{1,2}:\d{2})$/i.test(c)) return false;
          if (!(/[ぁ-んァ-ヶー一-龠]{2,}/.test(c))) return false;  // 日本語2文字以上必須
          if (/^[ぁ-んァ-ヶー]{2,4}(の|系|さん|ちゃん|くん)/.test(c)) return false;
          if (/^\d+年|\d+月$|^R\d+/.test(c)) return false;
          if (['月', '火', '水', '木', '金', '土', '日'].includes(c)) return false;
          if (/^(月|火|水|木|金|土|日)曜日?$/.test(c)) return false;
          if (/^第[一二三四五\d]/.test(c) && c.length <= 4) return false;
          if (/^(午前|午後|朝|昼|夕|夜)$/.test(c)) return false;
          if (/^[●・•◆◇■□▲△▼▽※]/.test(c)) return false;
          if (/ます[。.]?$|ましょう[。.]?$|ください[。.]?$|です[。.]?$/.test(c)) return false;
          if (/[。、]/.test(c) && c.length > 15) return false;
          if (/^(お仕事|健康と美|趣味活動|生活|やりたいこと)$/.test(c)) return false;
          if (/行事予定|デイサービス|プログラム/.test(c)) return false;
          // 動詞の断片や一般的な単語のみのものを除外
          if (/^(行こう|いこう|サイズ|つくろう|しよう|やろう|みよう|来るよ|行く|展|会|祭|日)$/.test(c)) return false;
          // カタカナのみで3文字以下は除外（「サイズ」「ズ」等）
          if (/^[ァ-ヶー]+$/.test(c) && c.length <= 3) return false;
          return true;
        };
        
        // 全セルをスキャンしてイベント名を収集
        const collectedEventNames = new Set<string>();
        const sheetEventsBeforeCount = events.length;
        
        // イベント名の正規化（類似イベントを統一）
        const normalizeEventName = (name: string): string => {
          // カラオケ系: 「カラオケbanbanに行こう」「カラオケにいこう」「カラオケに行こう」→「カラオケ」
          if (/^カラオケ/.test(name)) return 'カラオケ';
          // 「〜に行こう」「〜にいこう」「〜へ行こう」パターンの正規化
          const goPattern = name.replace(/(に|へ)(行こう|いこう|行く)$/, '');
          if (goPattern !== name) return goPattern;
          return name;
        };
        
        console.log(`🔍 Scanning all cells in sheet ${sheetName}...`);
        
        for (let i = 0; i < jsonData.length; i++) {
          const row = jsonData[i] as any[];
          if (!row) continue;
          
          for (let col = 0; col < row.length; col++) {
            const cellStr = cellToString(row[col]).trim();
            if (!cellStr) continue;
            
            // 年月タイトル行はスキップ
            if (/\d+年.*\d+月|R\d+\.\d+|令和\d+年/.test(cellStr)) continue;
            // 曜日ヘッダー行の単独セルはスキップ（ただし曜日+テキストは許可）
            if (/^(月|火|水|木|金|土|日)$/.test(cellStr)) continue;
            // 数字のみ（日付）はスキップ
            if (/^\d{1,2}$/.test(cellStr)) continue;
            
            // イベント名を抽出
            const names = extractEventNames(cellStr);
            for (const rawName of names) {
              const name = normalizeEventName(rawName);
              // 正規化後も有効なイベント名かチェック
              if (!isValidEventName(name)) continue;
              if (!collectedEventNames.has(name)) {
                collectedEventNames.add(name);
                
                events.push({
                  id: `hist-${eventId++}`,
                  date: new Date(year, month - 1, 1),  // 日付は仮（月だけ重要）
                  eventName: name,
                  eventType: 'イベント',
                  eventCategory: determineCategory(name)
                });
              }
            }
          }
        }
        
        const sheetEventCount = events.length - sheetEventsBeforeCount;
        console.log(`📊 Sheet ${sheetName}: extracted ${sheetEventCount} unique events for ${year}年${month}月`);
        if (sheetEventCount > 0) {
          const sheetEvents = events.slice(sheetEventsBeforeCount);
          console.log(`📋 Events: ${sheetEvents.map(e => e.eventName).join(', ')}`);
        }
      }
      
      console.log(`\n✅ Extracted ${events.length} events from Excel file`);
      
      // Group events by month for debugging
      const eventsByMonth: { [month: number]: number } = {};
      events.forEach(event => {
        const month = new Date(event.date).getMonth() + 1;
        eventsByMonth[month] = (eventsByMonth[month] || 0) + 1;
      });
      
      console.log('Events by month:', eventsByMonth);
      
      // 🔍 月ごとのイベント内容をチェックして、明らかに間違っている月を検出し、自動修正
      console.log('\n🔍 Checking for month mismatches and auto-correcting...');
      const monthEventCheck: { [month: number]: { 
        january: number; 
        february: number; 
        march: number; 
        april: number;
        may: number;
        june: number;
        july: number;
        august: number;
        september: number;
        october: number;
        november: number;
        december: number; 
        total: number 
      } } = {};
      
      // 各イベントがどの月に属するかを判定する関数
      const detectActualMonth = (eventName: string): number | null => {
        // 1月限定イベント
        if (eventName.includes('初詣') || eventName.includes('書初め') || eventName.includes('書き初め') ||
            eventName.includes('もちつき') || eventName.includes('餅つき') || eventName.includes('お正月') ||
            eventName.includes('新年') || eventName.includes('門松') || eventName.includes('おせち') ||
            eventName.includes('お年玉') || eventName.includes('年賀状')) {
          return 1;
        }
        // 2月限定イベント
        if (eventName.includes('節分') || eventName.includes('バレンタイン')) {
          return 2;
        }
        // 3月限定イベント
        if (eventName.includes('ひな祭り') || eventName.includes('雛祭り') || eventName.includes('ひなまつり')) {
          return 3;
        }
        // 4月限定イベント
        if (eventName.includes('お花見') || eventName.includes('花見')) {
          return 4;
        }
        // 5月限定イベント
        if (eventName.includes('こどもの日') || eventName.includes('子供の日') || 
            eventName.includes('こいのぼり') || eventName.includes('母の日')) {
          return 5;
        }
        // 6月限定イベント
        if (eventName.includes('父の日')) {
          return 6;
        }
        // 7月限定イベント
        if (eventName.includes('七夕') || eventName.includes('たなばた')) {
          return 7;
        }
        // 8月限定イベント
        if (eventName.includes('お盆') || eventName.includes('盆踊り')) {
          return 8;
        }
        // 9月限定イベント
        if (eventName.includes('お月見') || eventName.includes('月見') || eventName.includes('敬老の日')) {
          return 9;
        }
        // 10月限定イベント
        if (eventName.includes('ハロウィン') || eventName.includes('Halloween')) {
          return 10;
        }
        // 11月限定イベント
        if (eventName.includes('文化の日') || eventName.includes('文化祭')) {
          return 11;
        }
        // 12月限定イベント
        if (eventName.includes('忘年会') || eventName.includes('年末') || 
            eventName.includes('クリスマス') || eventName.includes('Xmas') ||
            eventName.includes('冬至') || eventName.includes('大晦日')) {
          return 12;
        }
        return null;
      };
      
      // 各イベントの内容から実際の月を推測
      events.forEach(event => {
        const labeledMonth = new Date(event.date).getMonth() + 1;
        const detectedMonth = detectActualMonth(event.eventName);
        
        if (!monthEventCheck[labeledMonth]) {
          monthEventCheck[labeledMonth] = { 
            january: 0, february: 0, march: 0, april: 0, may: 0, june: 0,
            july: 0, august: 0, september: 0, october: 0, november: 0, december: 0,
            total: 0 
          };
        }
        monthEventCheck[labeledMonth].total++;
        
        // 検出された月をカウント
        if (detectedMonth === 1) monthEventCheck[labeledMonth].january++;
        if (detectedMonth === 2) monthEventCheck[labeledMonth].february++;
        if (detectedMonth === 3) monthEventCheck[labeledMonth].march++;
        if (detectedMonth === 4) monthEventCheck[labeledMonth].april++;
        if (detectedMonth === 5) monthEventCheck[labeledMonth].may++;
        if (detectedMonth === 6) monthEventCheck[labeledMonth].june++;
        if (detectedMonth === 7) monthEventCheck[labeledMonth].july++;
        if (detectedMonth === 8) monthEventCheck[labeledMonth].august++;
        if (detectedMonth === 9) monthEventCheck[labeledMonth].september++;
        if (detectedMonth === 10) monthEventCheck[labeledMonth].october++;
        if (detectedMonth === 11) monthEventCheck[labeledMonth].november++;
        if (detectedMonth === 12) monthEventCheck[labeledMonth].december++;
      });
      
      // 月ごとに矛盾をチェックし、必要に応じて自動修正
      const monthNames = ['', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'];
      const correctedEvents: typeof events = [];
      
      Object.keys(monthEventCheck).forEach(monthStr => {
        const labeledMonth = parseInt(monthStr);
        const check = monthEventCheck[labeledMonth];
        
        // どの月のイベントが最も多いかを判定
        const monthCounts = [
          { month: 1, count: check.january },
          { month: 2, count: check.february },
          { month: 3, count: check.march },
          { month: 4, count: check.april },
          { month: 5, count: check.may },
          { month: 6, count: check.june },
          { month: 7, count: check.july },
          { month: 8, count: check.august },
          { month: 9, count: check.september },
          { month: 10, count: check.october },
          { month: 11, count: check.november },
          { month: 12, count: check.december }
        ];
        
        // 最も多い月を見つける
        const maxCount = Math.max(...monthCounts.map(m => m.count));
        const dominantMonth = monthCounts.find(m => m.count === maxCount && m.count >= 3);
        
        // ラベルされた月と実際の内容が異なる場合
        if (dominantMonth && dominantMonth.month !== labeledMonth && dominantMonth.count >= 3) {
          console.warn(`⚠️ MISLABELED SHEET DETECTED!`);
          console.warn(`   Labeled as: ${monthNames[labeledMonth]} (${labeledMonth}月)`);
          console.warn(`   Actual content: ${monthNames[dominantMonth.month]} (${dominantMonth.month}月) - ${dominantMonth.count} specific events found`);
          console.warn(`   🔧 AUTO-CORRECTING: Changing all events from ${labeledMonth}月 to ${dominantMonth.month}月`);
          
          // このラベル月のイベントを全て正しい月に修正
          events.forEach(event => {
            const eventMonth = new Date(event.date).getMonth() + 1;
            if (eventMonth === labeledMonth) {
              const correctedDate = new Date(event.date);
              correctedDate.setMonth(dominantMonth.month - 1);
              event.date = correctedDate;
              console.log(`   ✅ Corrected: "${event.eventName}" from ${labeledMonth}月 to ${dominantMonth.month}月`);
            }
          });
        } else if (labeledMonth !== 1 && check.january >= 3) {
          console.warn(`⚠️ WARNING: ${monthNames[labeledMonth]} contains ${check.january} January-specific events`);
          console.warn(`   Consider checking if this sheet is mislabeled`);
        } else if (labeledMonth !== 2 && check.february >= 2) {
          console.warn(`⚠️ WARNING: ${monthNames[labeledMonth]} contains ${check.february} February-specific events`);
        } else if (labeledMonth !== 3 && check.march >= 2) {
          console.warn(`⚠️ WARNING: ${monthNames[labeledMonth]} contains ${check.march} March-specific events`);
        } else if (labeledMonth !== 12 && check.december >= 2) {
          console.warn(`⚠️ WARNING: ${monthNames[labeledMonth]} contains ${check.december} December-specific events`);
        }
      });
      
      console.log('✅ Month mismatch check and auto-correction complete\n');
      
      // Show sample events
      if (events.length > 0) {
        console.log('\n📋 Sample events (first 10):');
        events.slice(0, 10).forEach((event, index) => {
          const date = new Date(event.date);
          console.log(`  ${index + 1}. ${date.getMonth() + 1}/${date.getDate()} - ${event.eventName} (${event.eventCategory})`);
        });
      }
      
      const historicalSchedule: HistoricalSchedule = {
        id: `historical-${Date.now()}`,
        year: new Date().getFullYear(),
        month: new Date().getMonth() + 1,
        events: events,
        uploadedAt: new Date()
      };

      // Store the historical schedule for future reference
      this.uploadedHistoricalSchedules.push(historicalSchedule);
      console.log('\n✅ Historical schedule stored for future reference');
      console.log('Total uploaded historical schedules:', this.uploadedHistoricalSchedules.length);
      console.log('⚠️ 重要: ページをリフレッシュするとこのデータは消えます！');

      return {
        success: true,
        data: historicalSchedule
      };
      
    } catch (error) {
      console.error('❌ Error parsing Excel file:', error);
      return {
        success: false,
        error: {
          code: 'EXCEL_PARSE_ERROR',
          message: `Excelファイルの解析に失敗しました: ${error}`,
          timestamp: new Date()
        }
      };
    }
  }

  // Theme Management
  async getAvailableThemes(): Promise<ScheduleTheme[]> {
    await delay(300);
    return this.themes;
  }

  async updateScheduleTheme(scheduleId: string, themeId: string): Promise<MonthlySchedule> {
    await delay(500);
    
    const scheduleIndex = this.schedules.findIndex(s => s.id === scheduleId);
    if (scheduleIndex === -1) {
      throw new Error('スケジュールが見つかりません');
    }

    const theme = this.themes.find(t => t.id === themeId);
    if (!theme) {
      throw new Error('テーマが見つかりません');
    }

    this.schedules[scheduleIndex].theme = theme;
    return this.schedules[scheduleIndex];
  }

  // Custom Image Upload
  async uploadScheduleImage(scheduleId: string, imageFile: File, imageType: 'header' | 'background'): Promise<string> {
    console.log('=== MOCK API SCHEDULE IMAGE UPLOAD START ===');
    console.log('MockAPI: uploadScheduleImage called', { scheduleId, imageType, fileName: imageFile.name });
    await delay(1000);
    
    try {
      console.log('MockAPI: Step 1 - Converting file to base64');
      // Convert file to base64 for mock storage
      const base64 = await this.fileToBase64(imageFile);
      console.log('MockAPI: Step 2 - File converted to base64, length:', base64.length);
      
      console.log('MockAPI: Step 3 - Storing image in memory');
      const imageKey = `${scheduleId}-${imageType}`;
      this.customImages.set(imageKey, base64);

      console.log('MockAPI: Step 4 - Updating schedule with custom image');
      // Update schedule with custom image
      const scheduleIndex = this.schedules.findIndex(s => s.id === scheduleId);
      if (scheduleIndex >= 0) {
        if (!this.schedules[scheduleIndex].customImages) {
          this.schedules[scheduleIndex].customImages = {};
        }
        
        if (imageType === 'header') {
          this.schedules[scheduleIndex].customImages!.headerImage = base64;
        } else {
          this.schedules[scheduleIndex].customImages!.backgroundImage = base64;
        }
        console.log('MockAPI: Schedule updated with custom image');
      } else {
        console.warn('MockAPI: Schedule not found for ID:', scheduleId);
      }

      console.log('=== MOCK API SCHEDULE IMAGE UPLOAD SUCCESS ===');
      return base64;
    } catch (error) {
      console.error('=== MOCK API SCHEDULE IMAGE UPLOAD ERROR ===');
      console.error('MockAPI: Error uploading schedule image:', error);
      throw new Error('Failed to upload schedule image');
    }
  }

  // Upload monthly default images
  async uploadMonthlyImage(month: number, imageFile: File, imageType: 'header' | 'background'): Promise<string> {
    console.log('=== MOCK API MONTHLY IMAGE UPLOAD START ===');
    console.log('MockAPI: uploadMonthlyImage called', { month, imageType, fileName: imageFile.name });
    await delay(1000);
    
    try {
      console.log('MockAPI: Step 1 - Converting file to base64');
      // Convert file to base64 for mock storage
      const base64 = await this.fileToBase64(imageFile);
      console.log('MockAPI: Step 2 - File converted to base64, length:', base64.length);
      
      console.log('MockAPI: Step 3 - Storing monthly image');
      // Store as monthly default image
      if (!this.uploadedMonthlyImages[month]) {
        this.uploadedMonthlyImages[month] = {};
      }
      
      if (imageType === 'header') {
        this.uploadedMonthlyImages[month].header = base64;
      } else {
        this.uploadedMonthlyImages[month].background = base64;
      }

      console.log('MockAPI: Step 4 - Monthly image stored successfully', { month, imageType });
      console.log('MockAPI: Current uploaded monthly images after storage:', this.uploadedMonthlyImages);
      console.log('MockAPI: Specific month data:', this.uploadedMonthlyImages[month]);
      console.log('=== MOCK API MONTHLY IMAGE UPLOAD SUCCESS ===');
      return base64;
    } catch (error) {
      console.error('=== MOCK API MONTHLY IMAGE UPLOAD ERROR ===');
      console.error('MockAPI: Error uploading monthly image:', error);
      throw new Error('Failed to upload monthly image');
    }
  }

  // Get monthly default images
  async getMonthlyImages(month: number): Promise<{ header?: string; background?: string }> {
    console.log('=== GET MONTHLY IMAGES ===');
    console.log('Requested month:', month);
    console.log('All uploaded monthly images:', this.uploadedMonthlyImages);
    await delay(300);
    
    const uploadedImages = this.uploadedMonthlyImages[month];
    const defaultImages = this.monthlyImages[month as keyof typeof this.monthlyImages];
    
    console.log('Uploaded images for month', month, ':', uploadedImages);
    console.log('Default images available:', defaultImages ? 'Yes' : 'No');
    
    const result = {
      header: uploadedImages?.header || defaultImages?.header,
      background: uploadedImages?.background || defaultImages?.background
    };
    
    console.log('Returning monthly images:', result);
    console.log('=== GET MONTHLY IMAGES END ===');
    
    return result;
  }

  private fileToBase64(file: File): Promise<string> {
    console.log('MockAPI: Converting file to base64:', { name: file.name, size: file.size, type: file.type });
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      // Add timeout to prevent hanging
      const timeout = setTimeout(() => {
        console.error('MockAPI: File conversion timeout');
        reject(new Error('File conversion timeout'));
      }, 10000); // 10 second timeout
      
      reader.readAsDataURL(file);
      reader.onload = () => {
        clearTimeout(timeout);
        const result = reader.result as string;
        console.log('MockAPI: File conversion successful, base64 length:', result.length);
        resolve(result);
      };
      reader.onerror = error => {
        clearTimeout(timeout);
        console.error('MockAPI: File conversion failed:', error);
        reject(error);
      };
    });
  }
  private getBalancedCategory(
    availableCategories: EventCategory[], 
    monthlyTracker: { [key: string]: number },
    weeklyTracker: { [key: string]: number },
    dailyTracker: { [key: string]: number },
    isWeekend: boolean
  ): EventCategory {
    // Calculate weights based on usage frequency (less used = higher weight)
    const categoryWeights: { [key: string]: number } = {};
    
    // Base weights - all categories start equal
    availableCategories.forEach(category => {
      categoryWeights[category] = 1.0;
    });
    
    // Reduce weight for overused categories in the month
    const totalMonthlyUsage = Object.values(monthlyTracker).reduce((sum, count) => sum + count, 0);
    if (totalMonthlyUsage > 0) {
      availableCategories.forEach(category => {
        const usage = monthlyTracker[category] || 0;
        const averageUsage = totalMonthlyUsage / availableCategories.length;
        
        // If this category is used more than average, reduce its weight
        if (usage > averageUsage) {
          categoryWeights[category] *= 0.6; // Reduce weight
        }
      });
    }
    
    // Further reduce weight for overused categories in the current week
    const totalWeeklyUsage = Object.values(weeklyTracker).reduce((sum, count) => sum + count, 0);
    if (totalWeeklyUsage > 0) {
      availableCategories.forEach(category => {
        const weeklyUsage = weeklyTracker[category] || 0;
        
        // If this category was used multiple times this week, reduce weight
        if (weeklyUsage >= 3) {
          categoryWeights[category] *= 0.1; // Heavily reduce
        } else if (weeklyUsage >= 2) {
          categoryWeights[category] *= 0.3; // Significantly reduce
        } else if (weeklyUsage >= 1) {
          categoryWeights[category] *= 0.7; // Moderately reduce
        }
      });
    }
    
    // Most importantly, ensure variety on the same day of week
    const totalDailyUsage = Object.values(dailyTracker).reduce((sum, count) => sum + count, 0);
    if (totalDailyUsage > 0) {
      availableCategories.forEach(category => {
        const dailyUsage = dailyTracker[category] || 0;
        
        // Heavily penalize categories that have been used on this day of week
        if (dailyUsage >= 2) {
          categoryWeights[category] *= 0.05; // Almost eliminate
        } else if (dailyUsage >= 1) {
          categoryWeights[category] *= 0.2; // Heavily reduce
        }
      });
    }
    
    // Apply weekend preferences (but don't override balance too much)
    if (isWeekend) {
      // Boost recreational categories on weekends
      if (availableCategories.includes(EventCategory.Hobby)) {
        categoryWeights[EventCategory.Hobby] *= 1.3;
      }
      if (availableCategories.includes(EventCategory.Life)) {
        categoryWeights[EventCategory.Life] *= 1.2;
      }
      // Reduce work category weight on weekends
      if (availableCategories.includes(EventCategory.Work)) {
        categoryWeights[EventCategory.Work] *= 0.4;
      }
    } else {
      // Boost work and health categories on weekdays
      if (availableCategories.includes(EventCategory.Work)) {
        categoryWeights[EventCategory.Work] *= 1.1;
      }
      if (availableCategories.includes(EventCategory.HealthBeauty)) {
        categoryWeights[EventCategory.HealthBeauty] *= 1.1;
      }
    }
    
    // Ensure no weight goes to zero (always keep some randomness)
    availableCategories.forEach(category => {
      if (categoryWeights[category] < 0.01) {
        categoryWeights[category] = 0.01;
      }
    });
    
    // Weighted random selection
    const totalWeight = Object.values(categoryWeights).reduce((sum, weight) => sum + weight, 0);
    let random = Math.random() * totalWeight;
    
    for (const category of availableCategories) {
      random -= categoryWeights[category];
      if (random <= 0) {
        return category;
      }
    }
    
    // Fallback to first available category
    return availableCategories[0];
  }

  private getSeasonByMonth(month: number): 'spring' | 'summer' | 'autumn' | 'winter' {
    if (month >= 3 && month <= 5) return 'spring';
    if (month >= 6 && month <= 8) return 'summer';
    if (month >= 9 && month <= 11) return 'autumn';
    return 'winter';
  }

  // 履歴データからイベント名を取得（アップロードされたファイルのイベントのみ使用）
  private getEventNameFromHistoryOrSeasonal(
    category: EventCategory, 
    month: number, 
    day: number, 
    isWeekend: boolean = false, 
    usedEvents: Set<string> = new Set(),
    usedEventsForDayOfWeek: string[] = [],  // この曜日で既に使用したイベント（月全体）
    eventsAddedToday: string[] = []  // 今日既に追加されたイベント
  ): string | null {
    console.log(`Getting event name for category: ${category}, month: ${month}, day: ${day}, isWeekend: ${isWeekend}`);
    console.log(`Currently used events: ${usedEvents.size}`);
    console.log(`Events used for this day of week in this month: ${usedEventsForDayOfWeek.join(', ')}`);
    console.log(`Events already added today: ${eventsAddedToday.join(', ')}`);
    
    // イベント名が日付に適切かチェックする関数
    const isEventAppropriate = (eventName: string, targetMonth: number, targetDay: number): boolean => {
      // 人名を含むイベントを除外
      // パターン: 「○○の」「○○系」など（○○は2-4文字のひらがな/カタカナ）
      if (/[ぁ-んァ-ヶー]{2,4}(の|系|さん|ちゃん|くん)/.test(eventName)) {
        console.log(`  ⚠️ Filtering out event with person name: "${eventName}"`);
        return false;
      }
      
      // 1月限定イベント（他の月では使用しない）
      if (targetMonth !== 1) {
        if (eventName.includes('初詣') || eventName.includes('お正月') || 
            eventName.includes('新年') || eventName.includes('門松') ||
            eventName.includes('書初め') || eventName.includes('おせち')) {
          return false;
        }
      }
      
      // 2月の特定イベントの日付制限
      if (targetMonth === 2) {
        if (eventName.includes('節分') && targetDay > 3) return false;
        if (eventName.includes('バレンタイン') && targetDay > 14) return false;
      }
      // 2月限定イベント（他の月では使用しない）
      if (targetMonth !== 2) {
        if (eventName.includes('節分') || eventName.includes('バレンタイン')) {
          return false;
        }
      }
      
      // 3月のひな祭り関連イベントは3月3日まで
      if (targetMonth === 3 && eventName.includes('ひな祭り') && targetDay > 3) return false;
      // 3月限定イベント（他の月では使用しない）
      if (targetMonth !== 3 && eventName.includes('ひな祭り')) {
        return false;
      }
      
      // 4月限定イベント
      if (targetMonth !== 4 && (eventName.includes('お花見') || eventName.includes('桜'))) {
        return false;
      }
      
      // 5月のこどもの日関連イベントは5月5日まで
      if (targetMonth === 5 && eventName.includes('こどもの日') && targetDay > 5) return false;
      // 5月限定イベント（他の月では使用しない）
      if (targetMonth !== 5 && (eventName.includes('こどもの日') || eventName.includes('こいのぼり') || eventName.includes('母の日'))) {
        return false;
      }
      
      // 6月限定イベント
      if (targetMonth !== 6 && (eventName.includes('父の日') || eventName.includes('梅雨') || eventName.includes('紫陽花'))) {
        return false;
      }
      
      // 7月の七夕関連イベントは7月7日まで
      if (targetMonth === 7 && eventName.includes('七夕') && targetDay > 7) return false;
      // 7月限定イベント（他の月では使用しない）
      if (targetMonth !== 7 && (eventName.includes('七夕') || eventName.includes('夏祭り'))) {
        return false;
      }
      
      // 8月限定イベント
      if (targetMonth !== 8 && (eventName.includes('お盆') || eventName.includes('花火'))) {
        return false;
      }
      
      // 9月限定イベント
      if (targetMonth !== 9 && (eventName.includes('お月見') || eventName.includes('敬老の日'))) {
        return false;
      }
      
      // 10月限定イベント
      if (targetMonth !== 10 && (eventName.includes('ハロウィン') || eventName.includes('運動会'))) {
        return false;
      }
      
      // 11月限定イベント
      if (targetMonth !== 11 && (eventName.includes('文化の日') || eventName.includes('文化祭'))) {
        return false;
      }
      
      // 12月限定イベント
      if (targetMonth !== 12 && (eventName.includes('クリスマス') || eventName.includes('年末') || eventName.includes('冬至'))) {
        return false;
      }
      
      // 果物・野菜の収穫時期による制限
      // いちご狩り: 1-5月
      if ((targetMonth < 1 || targetMonth > 5) && eventName.includes('いちご')) {
        return false;
      }
      
      // さくらんぼ狩り: 6-7月
      if ((targetMonth < 6 || targetMonth > 7) && eventName.includes('さくらんぼ')) {
        return false;
      }
      
      // ブルーベリー狩り: 7-8月
      if ((targetMonth < 7 || targetMonth > 8) && eventName.includes('ブルーベリー')) {
        return false;
      }
      
      // 桃狩り: 7-8月
      if ((targetMonth < 7 || targetMonth > 8) && eventName.includes('桃')) {
        return false;
      }
      
      // ぶどう狩り: 8-10月
      if ((targetMonth < 8 || targetMonth > 10) && (eventName.includes('ぶどう') || eventName.includes('ブドウ') || eventName.includes('葡萄'))) {
        return false;
      }
      
      // 梨狩り: 8-10月
      if ((targetMonth < 8 || targetMonth > 10) && eventName.includes('梨')) {
        return false;
      }
      
      // りんご狩り: 9-11月
      if ((targetMonth < 9 || targetMonth > 11) && (eventName.includes('りんご') || eventName.includes('リンゴ') || eventName.includes('林檎'))) {
        return false;
      }
      
      // 柿狩り: 10-11月
      if ((targetMonth < 10 || targetMonth > 11) && eventName.includes('柿')) {
        return false;
      }
      
      // みかん狩り: 10-12月
      if ((targetMonth < 10 || targetMonth > 12) && (eventName.includes('みかん') || eventName.includes('ミカン') || eventName.includes('蜜柑'))) {
        return false;
      }
      
      // 栗拾い: 9-10月
      if ((targetMonth < 9 || targetMonth > 10) && eventName.includes('栗')) {
        return false;
      }
      
      // 芋掘り: 9-11月
      if ((targetMonth < 9 || targetMonth > 11) && (eventName.includes('芋掘り') || eventName.includes('いも掘り') || eventName.includes('さつまいも'))) {
        return false;
      }
      
      return true;
    };
    
    // 人名のみをチェックする関数（同じ月のイベント用）
    const hasPersonName = (eventName: string): boolean => {
      return /[ぁ-んァ-ヶー]{2,4}(の|系|さん|ちゃん|くん)/.test(eventName);
    };
    
    // 明らかに季節外れのイベントをチェックする関数（同じ月でも除外すべきイベント）
    const isObviouslyWrongSeason = (eventName: string, targetMonth: number): boolean => {
      // 1月限定イベントが他の月にある場合
      if (targetMonth !== 1) {
        if (eventName.includes('初詣') || eventName.includes('お正月') || eventName.includes('新年') ||
            eventName.includes('書初め') || eventName.includes('書き初め') || eventName.includes('門松') ||
            eventName.includes('おせち') || eventName.includes('お年玉')) {
          console.log(`  🚫 Filtering out January-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 2月限定イベントが他の月にある場合
      if (targetMonth !== 2) {
        if (eventName.includes('節分') || eventName.includes('バレンタイン')) {
          console.log(`  🚫 Filtering out February-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 3月限定イベントが他の月にある場合
      if (targetMonth !== 3) {
        if (eventName.includes('ひな祭り') || eventName.includes('雛祭り')) {
          console.log(`  🚫 Filtering out March-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 4月限定イベントが他の月にある場合
      if (targetMonth !== 4) {
        if (eventName.includes('お花見') || eventName.includes('花見')) {
          console.log(`  🚫 Filtering out April-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 5月限定イベントが他の月にある場合
      if (targetMonth !== 5) {
        if (eventName.includes('こどもの日') || eventName.includes('子供の日') || 
            eventName.includes('こいのぼり') || eventName.includes('母の日')) {
          console.log(`  🚫 Filtering out May-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 6月限定イベントが他の月にある場合
      if (targetMonth !== 6) {
        if (eventName.includes('父の日')) {
          console.log(`  🚫 Filtering out June-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 7月限定イベントが他の月にある場合
      if (targetMonth !== 7) {
        if (eventName.includes('七夕') || eventName.includes('たなばた')) {
          console.log(`  🚫 Filtering out July-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 8月限定イベントが他の月にある場合
      if (targetMonth !== 8) {
        if (eventName.includes('お盆') || eventName.includes('盆踊り')) {
          console.log(`  🚫 Filtering out August-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 9月限定イベントが他の月にある場合
      if (targetMonth !== 9) {
        if (eventName.includes('お月見') || eventName.includes('月見') || eventName.includes('敬老の日')) {
          console.log(`  🚫 Filtering out September-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 10月限定イベントが他の月にある場合
      if (targetMonth !== 10) {
        if (eventName.includes('ハロウィン') || eventName.includes('Halloween')) {
          console.log(`  🚫 Filtering out October-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 11月限定イベントが他の月にある場合
      if (targetMonth !== 11) {
        if (eventName.includes('文化の日') || eventName.includes('文化祭')) {
          console.log(`  🚫 Filtering out November-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      // 12月限定イベントが他の月にある場合
      if (targetMonth !== 12) {
        if (eventName.includes('忘年会') || eventName.includes('年末') || 
            eventName.includes('クリスマス') || eventName.includes('Xmas') ||
            eventName.includes('冬至') || eventName.includes('大晦日')) {
          console.log(`  🚫 Filtering out December-only event in month ${targetMonth}: "${eventName}"`);
          return true;
        }
      }
      
      return false;
    };
    
    // ステップ1: アップロードされた履歴データから【同じ月のみ】の未使用イベントを検索（カテゴリ一致）
    let historicalEvents = this.uploadedHistoricalSchedules
      .flatMap(schedule => schedule.events)
      .filter(event => {
        const eventMonth = new Date(event.date).getMonth() + 1;
        return event.eventCategory === category && 
               eventMonth === month && 
               !usedEvents.has(event.eventName) &&
               !hasPersonName(event.eventName) &&
               !isObviouslyWrongSeason(event.eventName, month) &&
               !eventsAddedToday.includes(event.eventName);
      });
    
    if (historicalEvents.length > 0) {
      const randomEvent = historicalEvents[Math.floor(Math.random() * historicalEvents.length)];
      console.log(`✅ Step1: Historical event (same month, same category): ${randomEvent.eventName}`);
      usedEvents.add(randomEvent.eventName);
      return randomEvent.eventName;
    }
    
    // ステップ2: 同じ月、カテゴリ無視で未使用イベントを検索
    historicalEvents = this.uploadedHistoricalSchedules
      .flatMap(schedule => schedule.events)
      .filter(event => {
        const eventMonth = new Date(event.date).getMonth() + 1;
        return eventMonth === month && 
               !usedEvents.has(event.eventName) &&
               !hasPersonName(event.eventName) &&
               !isObviouslyWrongSeason(event.eventName, month) &&
               !eventsAddedToday.includes(event.eventName);
      });
    
    if (historicalEvents.length > 0) {
      const randomEvent = historicalEvents[Math.floor(Math.random() * historicalEvents.length)];
      console.log(`✅ Step2: Historical event (same month, any category): ${randomEvent.eventName}`);
      usedEvents.add(randomEvent.eventName);
      return randomEvent.eventName;
    }
    
    // ステップ3: 同じ月のデータが全て使用済み → イベントなし
    // （他の月のデータは使用しない。その月のアップロードデータのみ使用する）
    console.log(`⚠️ All historical events for month ${month} used up. No more events to assign.`);
    return null;
  }

  private getSeasonalEventNameByCategory(category: EventCategory, month: number, day: number, isWeekend: boolean = false, usedEvents: Set<string> = new Set()): string {
    // 日付に基づいてイベント名をフィルタリング
    const shouldExcludeEvent = (eventName: string, month: number, day: number): boolean => {
      // 2月の特定イベントの日付制限
      if (month === 2) {
        // 節分関連イベントは2月3日まで
        if (eventName.includes('節分') && day > 3) {
          return true;
        }
        // バレンタイン関連イベントは2月14日まで
        if (eventName.includes('バレンタイン') && day > 14) {
          return true;
        }
      }
      // 3月のひな祭り関連イベントは3月3日まで
      if (month === 3 && eventName.includes('ひな祭り') && day > 3) {
        return true;
      }
      // 5月のこどもの日関連イベントは5月5日まで
      if (month === 5 && eventName.includes('こどもの日') && day > 5) {
        return true;
      }
      // 7月の七夕関連イベントは7月7日まで
      if (month === 7 && eventName.includes('七夕') && day > 7) {
        return true;
      }
      return false;
    };
    
    // 季節感のあるイベント名を月ごとに定義（一般的なイベント名を追加）
    const seasonalEventNames = {
      // 1月 - 新年・冬
      1: {
        [EventCategory.Work]: isWeekend ? ['新年の飾り作り', '門松作り', '書初め準備'] : ['新年の大掃除', '年賀状整理', '正月飾り片付け'],
        [EventCategory.HealthBeauty]: isWeekend ? ['新年ヨガ', '初詣ウォーキング', '温泉気分入浴'] : ['新年体操', '冬の健康チェック', '乾燥肌ケア'],
        [EventCategory.Hobby]: isWeekend ? ['新年カラオケ大会', '書初め大会', '福笑いゲーム'] : ['新年俳句', '冬の読書会', '将棋・囲碁'],
        [EventCategory.Life]: isWeekend ? ['新年お茶会', '初詣外出', 'おせち料理試食'] : ['新年挨拶回り', '冬の買い物', '新年の計画立て']
      },
      // 2月 - 一般的な冬のイベント（特定日付のイベントは日付制限付き）
      2: {
        [EventCategory.Work]: isWeekend ? ['冬の手工芸', '室内装飾作り', '春の準備作業', '節分飾り作り', 'バレンタインお菓子作り', '手芸作業', '編み物', '折り紙教室', 'おやつ作り'] : ['冬の清掃', '整理整頓', '園芸準備', '節分豆まき準備', 'バレンタイン装飾', '洗濯たたみ', '掃除活動', '調理補助', 'おやつ作り'],
        [EventCategory.HealthBeauty]: isWeekend ? ['冬のヨガ', '温泉気分入浴', 'アロマセラピー', '節分ヨガ', 'バレンタインアロマ', 'リラクゼーション', 'マッサージ', '足湯'] : ['冬の体操', '健康チェック', '乾燥対策ケア', '立春体操', '節分健康体操', 'ストレッチ', 'ラジオ体操', '美容ケア'],
        [EventCategory.Hobby]: isWeekend ? ['音楽鑑賞会', 'カラオケ大会', '映画鑑賞', '節分ゲーム大会', 'バレンタイン音楽会', 'ゲーム大会', '俳句会', 'お絵かき教室'] : ['読書会', '工作教室', '俳句会', '節分の歌', 'バレンタインカード作り', '将棋・囲碁', '書道', 'パズル'],
        [EventCategory.Life]: isWeekend ? ['お茶会', '散歩', 'お出かけ', '節分お茶会', 'バレンタインパーティー', '外出イベント', 'ピクニック', '季節のお祭り'] : ['買い物', '外出', '交流会', '節分の豆まき', 'バレンタイン買い物', '茶話会', '外出レクリエーション']
      },
      // 3月 - ひな祭り・春の始まり
      3: {
        [EventCategory.Work]: isWeekend ? ['ひな祭り飾り作り', '春の花植え', '卒業記念品作り'] : ['ひな祭り準備', '春の大掃除', '桜の枝整理'],
        [EventCategory.HealthBeauty]: isWeekend ? ['ひな祭りヨガ', '春のアロマ', '花粉症対策'] : ['春の健康体操', 'ひな祭り美容', '春のストレッチ'],
        [EventCategory.Hobby]: isWeekend ? ['ひな祭り音楽会', '春の映画鑑賞', '桜の絵画教室'] : ['ひな祭り俳句', '春の読書', '桜の工作'],
        [EventCategory.Life]: isWeekend ? ['ひな祭りお茶会', '春のピクニック', '桜見外出'] : ['ひな祭り', '春の買い物', '桜散歩']
      },
      // 4月 - 桜・新緑・新年度
      4: {
        [EventCategory.Work]: isWeekend ? ['桜の飾り作り', '春野菜植え', 'お花見弁当作り'] : ['桜の手入れ', '春の園芸', '新緑の清掃'],
        [EventCategory.HealthBeauty]: isWeekend ? ['お花見ヨガ', '春のリラクゼーション', '桜アロマ'] : ['桜体操', '春の健康チェック', '新緑ウォーキング'],
        [EventCategory.Hobby]: isWeekend ? ['お花見カラオケ', '桜の絵画', '春の音楽会'] : ['桜俳句', '春の読書', '花見の歌'],
        [EventCategory.Life]: isWeekend ? ['お花見パーティー', '春のお茶会', '桜見ドライブ'] : ['お花見散歩', '春の買い物', '桜見外出']
      },
      // 5月 - こどもの日・新緑・母の日
      5: {
        [EventCategory.Work]: isWeekend ? ['こいのぼり作り', '母の日ギフト作り', '新緑の手入れ'] : ['こどもの日準備', '母の日準備', '初夏の園芸'],
        [EventCategory.HealthBeauty]: isWeekend ? ['こどもの日ヨガ', '母の日美容', '新緑アロマ'] : ['こどもの日体操', '初夏の健康体操', '新緑ストレッチ'],
        [EventCategory.Hobby]: isWeekend ? ['こどもの日音楽会', '母の日コンサート', '新緑絵画'] : ['こいのぼり工作', '母の日カード作り', '新緑俳句'],
        [EventCategory.Life]: isWeekend ? ['こどもの日お祭り', '母の日お茶会', '新緑ピクニック'] : ['こどもの日', '母の日', '新緑散歩']
      },
      // 6月 - 梅雨・紫陽花・父の日
      6: {
        [EventCategory.Work]: isWeekend ? ['紫陽花飾り作り', '父の日ギフト作り', '梅雨の室内装飾'] : ['紫陽花の手入れ', '父の日準備', '梅雨の清掃'],
        [EventCategory.HealthBeauty]: isWeekend ? ['梅雨ヨガ', '父の日マッサージ', '紫陽花アロマ'] : ['梅雨の健康体操', '湿気対策ケア', '紫陽花ストレッチ'],
        [EventCategory.Hobby]: isWeekend ? ['梅雨の音楽会', '父の日コンサート', '紫陽花絵画'] : ['梅雨の読書', '父の日工作', '紫陽花俳句'],
        [EventCategory.Life]: isWeekend ? ['父の日パーティー', '梅雨のお茶会', '紫陽花見学'] : ['父の日', '梅雨の買い物', '紫陽花散歩']
      },
      // 7月 - 七夕・夏祭り・海
      7: {
        [EventCategory.Work]: isWeekend ? ['七夕飾り作り', '夏祭り準備', '夏野菜収穫'] : ['七夕準備', '夏の大掃除', '夏野菜の手入れ'],
        [EventCategory.HealthBeauty]: isWeekend ? ['七夕ヨガ', '夏祭りマッサージ', '夏のリラクゼーション'] : ['七夕体操', '夏の健康管理', '暑さ対策ケア'],
        [EventCategory.Hobby]: isWeekend ? ['七夕音楽会', '夏祭りカラオケ', '海の絵画教室'] : ['七夕短冊作り', '夏の読書', '海の俳句'],
        [EventCategory.Life]: isWeekend ? ['七夕祭り', '夏祭り', '海辺ピクニック'] : ['七夕', '夏の買い物', '涼しい散歩']
      },
      // 8月 - お盆・花火・夏休み
      8: {
        [EventCategory.Work]: isWeekend ? ['お盆飾り作り', '花火大会準備', '夏の思い出作り'] : ['お盆準備', '夏の園芸', '花火の清掃'],
        [EventCategory.HealthBeauty]: isWeekend ? ['お盆ヨガ', '花火見学ストレッチ', '夏バテ対策'] : ['お盆体操', '夏の健康体操', '熱中症予防'],
        [EventCategory.Hobby]: isWeekend ? ['お盆音楽会', '花火大会鑑賞', '夏の映画祭'] : ['お盆の歌', '花火の絵', '夏の工作'],
        [EventCategory.Life]: isWeekend ? ['お盆お茶会', '花火大会', '夏祭り外出'] : ['お盆', '夏の買い物', '涼しい時間の散歩']
      },
      // 9月 - 敬老の日・お月見・秋の始まり
      9: {
        [EventCategory.Work]: isWeekend ? ['お月見飾り作り', '敬老の日ギフト作り', '秋の花植え'] : ['お月見準備', '敬老の日準備', '秋の園芸'],
        [EventCategory.HealthBeauty]: isWeekend ? ['お月見ヨガ', '敬老の日マッサージ', '秋のアロマ'] : ['お月見体操', '秋の健康体操', '季節の変わり目ケア'],
        [EventCategory.Hobby]: isWeekend ? ['お月見音楽会', '敬老の日コンサート', '秋の絵画'] : ['お月見俳句', '敬老の日カード', '秋の読書'],
        [EventCategory.Life]: isWeekend ? ['お月見お茶会', '敬老の日お祝い', '秋のピクニック'] : ['お月見', '敬老の日', '秋の散歩']
      },
      // 10月 - ハロウィン・紅葉・運動会
      10: {
        [EventCategory.Work]: isWeekend ? ['ハロウィン飾り作り', '紅葉の飾り作り', '運動会準備'] : ['ハロウィン準備', '紅葉の手入れ', '秋の大掃除'],
        [EventCategory.HealthBeauty]: isWeekend ? ['ハロウィンヨガ', '紅葉アロマ', '運動会ストレッチ'] : ['ハロウィン体操', '紅葉ウォーキング', '秋の健康体操'],
        [EventCategory.Hobby]: isWeekend ? ['ハロウィンパーティー', '紅葉絵画', '運動会応援'] : ['ハロウィン工作', '紅葉俳句', '秋の読書'],
        [EventCategory.Life]: isWeekend ? ['ハロウィンお茶会', '紅葉狩り', '運動会見学'] : ['ハロウィン', '紅葉散歩', '秋の買い物']
      },
      // 11月 - 文化の日・紅葉・感謝祭
      11: {
        [EventCategory.Work]: isWeekend ? ['文化祭準備', '紅葉の押し花作り', '感謝祭飾り作り'] : ['文化の日準備', '紅葉の清掃', '秋の園芸'],
        [EventCategory.HealthBeauty]: isWeekend ? ['文化の日ヨガ', '紅葉リラクゼーション', '感謝祭マッサージ'] : ['文化の日体操', '紅葉ウォーキング', '秋の健康管理'],
        [EventCategory.Hobby]: isWeekend ? ['文化祭', '紅葉音楽会', '感謝祭コンサート'] : ['文化の日工作', '紅葉絵画', '感謝の俳句'],
        [EventCategory.Life]: isWeekend ? ['文化祭見学', '紅葉狩り外出', '感謝祭お茶会'] : ['文化の日', '紅葉散歩', '感謝の買い物']
      },
      // 12月 - クリスマス・年末・冬至
      12: {
        [EventCategory.Work]: isWeekend ? ['クリスマス飾り作り', '年末大掃除', 'お正月準備'] : ['クリスマス準備', '年末の整理', '冬の園芸'],
        [EventCategory.HealthBeauty]: isWeekend ? ['クリスマスヨガ', '年末リラクゼーション', '冬至ケア'] : ['クリスマス体操', '年末健康チェック', '冬の乾燥対策'],
        [EventCategory.Hobby]: isWeekend ? ['クリスマス音楽会', '年末映画鑑賞', '冬至コンサート'] : ['クリスマス工作', '年末の読書', '冬至俳句'],
        [EventCategory.Life]: isWeekend ? ['クリスマスパーティー', '年末お茶会', '冬至外出'] : ['クリスマス', '年末買い物', '冬の散歩']
      }
    };

    // 指定された月の季節イベント名を取得
    const monthlyEvents = seasonalEventNames[month as keyof typeof seasonalEventNames];
    if (monthlyEvents && monthlyEvents[category]) {
      const eventNames = monthlyEvents[category];
      
      // 日付に基づいてフィルタリング + 未使用のイベント名を探す
      const availableEvents = eventNames.filter(name => 
        !usedEvents.has(name) && !shouldExcludeEvent(name, month, day)
      );
      
      if (availableEvents.length > 0) {
        const selectedEvent = availableEvents[Math.floor(Math.random() * availableEvents.length)];
        usedEvents.add(selectedEvent); // 使用済みとしてマーク
        return selectedEvent;
      } else {
        // 全て使用済みまたは除外された場合は、除外されていないものから選択
        const nonExcludedEvents = eventNames.filter(name => !shouldExcludeEvent(name, month, day));
        if (nonExcludedEvents.length > 0) {
          const fallbackEvent = nonExcludedEvents[Math.floor(Math.random() * nonExcludedEvents.length)];
          return fallbackEvent + ' (再)'; // 重複を示すマーク
        } else {
          // 全て除外された場合は一般的なイベント名
          return this.getGenericEventName(category);
        }
      }
    }

    // フォールバック: 従来のイベント名を使用
    return this.getEventNameByCategory(category, isWeekend);
  }
  
  // 一般的なイベント名を返す（特定の日付に依存しない）
  private getGenericEventName(category: EventCategory): string {
    const genericNames = {
      [EventCategory.Work]: ['手工芸作業', '清掃活動', '園芸作業', '整理整頓', 'おやつ作り', 'お菓子作り'],
      [EventCategory.HealthBeauty]: ['健康体操', 'ストレッチ', 'リラクゼーション', '健康チェック'],
      [EventCategory.Hobby]: ['音楽鑑賞', '読書会', 'カラオケ', '工作教室'],
      [EventCategory.Life]: ['お茶会', '散歩', '買い物', 'お出かけ']
    };
    
    const names = genericNames[category];
    return names[Math.floor(Math.random() * names.length)];
  }

  private getEventNameByCategory(category: EventCategory, isWeekend: boolean = false): string {
    const weekdayEventNames = {
      [EventCategory.Work]: ['手工芸作業', '園芸作業', '清掃作業', '調理補助', '洗濯たたみ', '掃除活動', 'おやつ作り', 'お菓子作り'],
      [EventCategory.HealthBeauty]: ['健康体操', 'ストレッチ', 'マッサージ', '美容ケア', 'ラジオ体操', '足湯'],
      [EventCategory.Hobby]: ['カラオケ', '将棋・囲碁', '読書会', '映画鑑賞', '音楽鑑賞', '書道', '絵画', 'パズル'],
      [EventCategory.Life]: ['買い物', '散歩', '茶話会', '季節行事', '外出レクリエーション']
    };

    const weekendEventNames = {
      [EventCategory.Work]: ['園芸作業', '手工芸作業', '調理レクリエーション'],
      [EventCategory.HealthBeauty]: ['リラクゼーション', 'アロマテラピー', '温泉気分入浴', 'ヨガ'],
      [EventCategory.Hobby]: ['映画上映会', 'カラオケ大会', 'ゲーム大会', '音楽コンサート', 'お絵かき教室', '俳句会'],
      [EventCategory.Life]: ['外出イベント', 'お茶会', 'お誕生日会', '季節のお祭り', 'バーベキュー', 'ピクニック']
    };

    const eventNames = isWeekend ? weekendEventNames : weekdayEventNames;
    const names = eventNames[category];
    return names[Math.floor(Math.random() * names.length)];
  }

  private getEventTypeByCategory(category: EventCategory): string {
    const eventTypes = {
      [EventCategory.Work]: '作業',
      [EventCategory.HealthBeauty]: '健康・美容',
      [EventCategory.Hobby]: 'レクリエーション',
      [EventCategory.Life]: '生活支援'
    };

    return eventTypes[category];
  }

  // イベント名からカテゴリを判定する
  private determineCategoryFromName(eventName: string): EventCategory {
    const nameLower = eventName.toLowerCase();
    
    // 生活・Life keywords (優先度最高)
    if (nameLower.includes('お買い物') || nameLower.includes('買い物') || 
        nameLower.includes('ランチ') || nameLower.includes('お出かけ') || nameLower.includes('外出') ||
        nameLower.includes('ドライブ')) {
      return EventCategory.Life;
    }
    
    // 健康・美容・HealthBeauty keywords (優先度高)
    if (nameLower.includes('体操') || nameLower.includes('ヨガ') || nameLower.includes('ストレッチ') ||
        nameLower.includes('健康') || nameLower.includes('美容') || nameLower.includes('マッサージ') ||
        nameLower.includes('リラク') || nameLower.includes('アロマ') ||
        nameLower.includes('ウォーキング') || nameLower.includes('散歩') || nameLower.includes('ダンス') ||
        nameLower.includes('エクササイズ') || nameLower.includes('運動') || nameLower.includes('チェア') ||
        nameLower.includes('笑い')) {
      return EventCategory.HealthBeauty;
    }
    
    // 作業・Work keywords (農業系、販売系、おやつ作りのみ)
    if (nameLower.includes('園芸') || nameLower.includes('農') || nameLower.includes('畑') ||
        nameLower.includes('販売') ||
        nameLower.includes('おやつ作り') || nameLower.includes('お菓子作り')) {
      return EventCategory.Work;
    }
    
    // 趣味・レク・Hobby keywords
    if (nameLower.includes('レク') || nameLower.includes('カラオケ') || nameLower.includes('音楽') ||
        nameLower.includes('映画') || nameLower.includes('読書') || nameLower.includes('ゲーム') ||
        nameLower.includes('工作') || nameLower.includes('絵画') || nameLower.includes('書道') ||
        nameLower.includes('俳句') || nameLower.includes('将棋') || nameLower.includes('囲碁') ||
        nameLower.includes('パズル') || nameLower.includes('鑑賞')) {
      return EventCategory.Hobby;
    }
    
    // Default to Life
    return EventCategory.Life;
  }

  private getRandomUsers(users: User[], maxCount: number): User[] {
    const shuffled = [...users].sort(() => 0.5 - Math.random());
    const count = Math.min(Math.max(1, Math.floor(Math.random() * maxCount) + 1), users.length);
    return shuffled.slice(0, count);
  }

  // 履歴データ生成用：月ごとに適切なイベントを選択（大幅拡張版・重複回避機能付き）
  private getSeasonalEventForHistoricalData(month: number, usedNames: Set<string> = new Set()): { eventName: string; eventType: string; eventCategory: EventCategory } {
    // 月ごとの季節感のあるイベントデータベース（大幅拡張）
    const monthlyEvents = {
      1: [ // 1月 - 新年・冬（20個）
        { eventName: '新年お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '書初め大会', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '新年体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '新年の大掃除', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '初詣外出', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '冬の読書会', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '乾燥肌ケア', eventType: '美容活動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '年賀状整理', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: 'おせち料理試食', eventType: '食事活動', eventCategory: EventCategory.Life },
        { eventName: '福笑いゲーム', eventType: 'レクリエーション', eventCategory: EventCategory.Hobby },
        { eventName: '初詣ウォーキング', eventType: '運動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '門松作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '新年挨拶回り', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '新年カラオケ大会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '温泉気分入浴', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '正月飾り片付け', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: '冬の買い物', eventType: '外出支援', eventCategory: EventCategory.Life },
        { eventName: '将棋・囲碁', eventType: 'ゲーム活動', eventCategory: EventCategory.Hobby },
        { eventName: '冬の健康チェック', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '新年の計画立て', eventType: '生活支援', eventCategory: EventCategory.Work }
      ],
      2: [ // 2月 - バレンタイン・節分（19個）
        { eventName: 'バレンタインお茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '節分ゲーム大会', eventType: 'レクリエーション', eventCategory: EventCategory.Hobby },
        { eventName: '立春体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'バレンタイン装飾', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '梅見散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: 'バレンタイン音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '冬の温泉気分', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '節分豆まき準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: 'バレンタインパーティー', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: 'バレンタインカード作り', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: 'バレンタインアロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'バレンタインお菓子作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '節分お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '節分の歌', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '節分ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '節分飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '恋愛映画鑑賞', eventType: '娯楽活動', eventCategory: EventCategory.Life },
        { eventName: '冬の工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '冬の乾燥対策', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty }
      ],
      3: [ // 3月 - ひな祭り・春の始まり（20個）
        { eventName: 'ひな祭りお茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '桜の絵画教室', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '春の健康体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '春の大掃除', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: '桜見散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: 'ひな祭り俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '花粉症対策', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '春の花植え', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: 'ひな祭りパーティー', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '春の映画鑑賞', eventType: '娯楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'ひな祭りヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'ひな祭り飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '春のピクニック', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '桜の工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '春のアロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '桜の枝整理', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '卒業記念会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '春の読書', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '春のストレッチ', eventType: '柔軟運動', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'ひな祭り準備', eventType: '生活支援', eventCategory: EventCategory.Work }
      ],
      4: [ // 4月 - 桜・新緑・新年度（20個）
        { eventName: 'お花見お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '桜の絵画', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '桜体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '桜の手入れ', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: 'お花見散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: 'お花見カラオケ', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'お花見ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '春野菜植え', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: 'お花見パーティー', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '春の音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '春のリラクゼーション', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お花見弁当作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '桜見ドライブ', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '桜俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '春の健康チェック', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '新緑の清掃', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: '春のお茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '花見の歌', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '新緑ウォーキング', eventType: '運動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '桜の飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work }
      ],
      5: [ // 5月 - こどもの日・新緑・母の日（20個）
        { eventName: 'こどもの日お祭り', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: 'こいのぼり工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: 'こどもの日体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'こどもの日準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '母の日お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: 'こどもの日音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'こどもの日ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'こいのぼり作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '新緑ピクニック', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '母の日コンサート', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '母の日美容', eventType: '美容活動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '母の日ギフト作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '新緑散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '母の日カード作り', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '初夏の健康体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '新緑の手入れ', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '母の日', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '新緑絵画', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '新緑アロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '初夏の園芸', eventType: '園芸作業', eventCategory: EventCategory.Work }
      ],
      6: [ // 6月 - 梅雨・紫陽花・父の日（20個）
        { eventName: '父の日パーティー', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '梅雨の音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '梅雨ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '紫陽花の手入れ', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '梅雨のお茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '父の日コンサート', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '父の日マッサージ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '父の日準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '紫陽花見学', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '梅雨の読書', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '梅雨の健康体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '梅雨の清掃', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: '紫陽花散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '父の日工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '湿気対策ケア', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '紫陽花飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '父の日', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '紫陽花俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '紫陽花アロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '梅雨の室内装飾', eventType: '作業療法', eventCategory: EventCategory.Work }
      ],
      7: [ // 7月 - 七夕・夏祭り・海（20個）
        { eventName: '七夕祭り', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '七夕短冊作り', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '七夕体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '七夕準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '夏祭り', eventType: 'お祭り', eventCategory: EventCategory.Life },
        { eventName: '七夕音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '七夕ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '七夕飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '海辺ピクニック', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '夏祭りカラオケ', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '夏祭りマッサージ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '夏祭り準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '涼しい散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '海の絵画教室', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '夏のリラクゼーション', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '夏野菜収穫', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '夏の買い物', eventType: '外出支援', eventCategory: EventCategory.Life },
        { eventName: '夏の読書', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '夏の健康管理', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '夏の大掃除', eventType: '清掃', eventCategory: EventCategory.Work }
      ],
      8: [ // 8月 - お盆・花火・夏休み（20個）
        { eventName: 'お盆お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: 'お盆の歌', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'お盆体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お盆準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '花火大会', eventType: 'お祭り', eventCategory: EventCategory.Life },
        { eventName: '花火大会鑑賞', eventType: '娯楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'お盆ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お盆飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '夏祭り外出', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '夏の映画祭', eventType: '娯楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '花火見学ストレッチ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '花火大会準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '涼しい時間の散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '花火の絵', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '夏バテ対策', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '夏の園芸', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: 'お盆', eventType: '伝統行事', eventCategory: EventCategory.Life },
        { eventName: '夏の工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '熱中症予防', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '夏の思い出作り', eventType: '生活支援', eventCategory: EventCategory.Work }
      ],
      9: [ // 9月 - 敬老の日・お月見・秋の始まり（20個）
        { eventName: 'お月見お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: 'お月見俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: 'お月見体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お月見準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '敬老の日お祝い', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: 'お月見音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'お月見ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お月見飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '秋のピクニック', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '敬老の日コンサート', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '敬老の日マッサージ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '敬老の日準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '秋の散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '秋の絵画', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '秋のアロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '秋の花植え', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: 'お月見', eventType: '伝統行事', eventCategory: EventCategory.Life },
        { eventName: '敬老の日カード', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '秋の健康体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '秋の園芸', eventType: '園芸作業', eventCategory: EventCategory.Work }
      ],
      10: [ // 10月 - ハロウィン・紅葉・運動会（20個）
        { eventName: 'ハロウィンお茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: 'ハロウィン工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: 'ハロウィン体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'ハロウィン準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '紅葉狩り', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: 'ハロウィンパーティー', eventType: 'お祝い', eventCategory: EventCategory.Hobby },
        { eventName: 'ハロウィンヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'ハロウィン飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '運動会見学', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '紅葉絵画', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '紅葉アロマ', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '紅葉の手入れ', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '秋の買い物', eventType: '外出支援', eventCategory: EventCategory.Life },
        { eventName: '紅葉俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '紅葉ウォーキング', eventType: '運動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '秋の大掃除', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: 'ハロウィン', eventType: 'お祭り', eventCategory: EventCategory.Life },
        { eventName: '秋の読書', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '秋の健康体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '運動会準備', eventType: '生活支援', eventCategory: EventCategory.Work }
      ],
      11: [ // 11月 - 文化の日・紅葉・感謝祭（20個）
        { eventName: '文化祭見学', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '文化の日工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '文化の日体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '文化の日準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '紅葉狩り外出', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '文化祭', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '文化の日ヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: '文化祭準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '感謝祭お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: '紅葉音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '紅葉リラクゼーション', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '紅葉の押し花作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '紅葉散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '感謝の俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '紅葉ウォーキング', eventType: '運動', eventCategory: EventCategory.HealthBeauty },
        { eventName: '秋の園芸', eventType: '園芸作業', eventCategory: EventCategory.Work },
        { eventName: '文化の日', eventType: '祝日行事', eventCategory: EventCategory.Life },
        { eventName: '紅葉絵画', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: '秋の健康管理', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '感謝祭飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work }
      ],
      12: [ // 12月 - クリスマス・年末・冬至（20個）
        { eventName: 'クリスマスパーティー', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: 'クリスマス工作', eventType: '創作活動', eventCategory: EventCategory.Hobby },
        { eventName: 'クリスマス体操', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'クリスマス準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: '年末お茶会', eventType: '交流活動', eventCategory: EventCategory.Life },
        { eventName: 'クリスマス音楽会', eventType: '音楽活動', eventCategory: EventCategory.Hobby },
        { eventName: 'クリスマスヨガ', eventType: '運動療法', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'クリスマス飾り作り', eventType: '作業療法', eventCategory: EventCategory.Work },
        { eventName: '冬至外出', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '年末映画鑑賞', eventType: '娯楽活動', eventCategory: EventCategory.Hobby },
        { eventName: '年末リラクゼーション', eventType: 'リラクゼーション', eventCategory: EventCategory.HealthBeauty },
        { eventName: '年末大掃除', eventType: '清掃', eventCategory: EventCategory.Work },
        { eventName: '冬の散歩', eventType: '外出活動', eventCategory: EventCategory.Life },
        { eventName: '冬至俳句', eventType: '文学活動', eventCategory: EventCategory.Hobby },
        { eventName: '冬の乾燥対策', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: 'お正月準備', eventType: '生活支援', eventCategory: EventCategory.Work },
        { eventName: 'クリスマス', eventType: 'お祝い', eventCategory: EventCategory.Life },
        { eventName: '年末の読書', eventType: '文化活動', eventCategory: EventCategory.Hobby },
        { eventName: '年末健康チェック', eventType: '健康管理', eventCategory: EventCategory.HealthBeauty },
        { eventName: '冬の園芸', eventType: '園芸作業', eventCategory: EventCategory.Work }
      ]
    };

    const eventsForMonth = monthlyEvents[month as keyof typeof monthlyEvents] || monthlyEvents[1];
    
    // 未使用のイベントを優先選択
    const availableEvents = eventsForMonth.filter(event => !usedNames.has(event.eventName));
    
    if (availableEvents.length > 0) {
      const selectedEvent = availableEvents[Math.floor(Math.random() * availableEvents.length)];
      usedNames.add(selectedEvent.eventName); // 使用済みとしてマーク
      return selectedEvent;
    } else {
      // 全て使用済みの場合はランダム選択（重複を許可）
      const fallbackEvent = eventsForMonth[Math.floor(Math.random() * eventsForMonth.length)];
      return {
        ...fallbackEvent,
        eventName: fallbackEvent.eventName + ' (再)' // 重複を示すマーク
      };
    }
  }
}

// Export singleton instance
export const mockApiClient = new MockApiClient();